export default {
  // "dependencia": [
  //   {
  //     "id": "1",
  //     "dependencia": "Comisaria 2° Concepción",
  //     "domicilio": "(*) Comisaria Segunda - Juan Jufré 184 Este",
  //     "coordenadas1": "-31.522.374",
  //     "coordenadas2": "-68,524,446",
  //     "tel": "0264 4212526",
  //     "localidad": "San Juan"
  //   },
  //   {
  //     "id": "2",
  //     "dependencia": "Comisaria 3° Trinidad",
  //     "domicilio": "(*) Comisarìa 3ª Agustin Gomez 101 Este",
  //     "coordenadas1": "-31.552.529",
  //     "coordenadas2": "-68,522,540",
  //     "tel": "0264 4224505",
  //     "localidad": "San Juan"
  //   },
  //   {
  //     "id": "3",
  //     "dependencia": "Comisaria 4° Desamparados",
  //     "domicilio": "(*) Av. San Martín 2000 Oeste (4 desamparados)",
  //     "coordenadas1": "-31.530.745",
  //     "coordenadas2": "-68,553,597",
  //     "tel": "0264 4231880",
  //     "localidad": "San Juan"
  //   },
  //   {
  //     "id": "4",
  //     "dependencia": "Comisaria 5° Santa Lucía",
  //     "domicilio": "(*) Comisaria Quinta - Ramon Franco 670 Sur",
  //     "coordenadas1": "-31.540.824",
  //     "coordenadas2": "-68,497,023",
  //     "tel": "0264 4250040",
  //     "localidad": "Santa Lucía"
  //   },
  //   {
  //     "id": "5",
  //     "dependencia": "Comisaria 6° Rawson",
  //     "domicilio": "(*) Sarmiento 428 - Villa Krause 6",
  //     "coordenadas1": "-31.583.044",
  //     "coordenadas2": "-68,541,067",
  //     "tel": "0264 4240984",
  //     "localidad": "Villa Krause - Rawson"
  //   },
  //   {
  //     "id": "6",
  //     "dependencia": "Comisaria 7° Pocito",
  //     "domicilio": "(*) Cría. Séptima Dpto. Pocito - Calle Vidart Oeste 1043",
  //     "coordenadas1": "-31.657.341",
  //     "coordenadas2": "-68,579,184",
  //     "tel": "0264 4921074",
  //     "localidad": "Pocito"
  //   },
  //   {
  //     "id": "7",
  //     "dependencia": "Comisaria 8° Sarmiento",
  //     "domicilio": "(*) Cría Octava - Dpto Sarmiento Rivadavia s/n°",
  //     "coordenadas1": "-31.980.722",
  //     "coordenadas2": "-68,426,741",
  //     "tel": "0264 4941009",
  //     "localidad": "Media Agua - Sarmiento"
  //   },
  //   {
  //     "id": "8",
  //     "dependencia": "Comisaria 9° Caucete",
  //     "domicilio": "(*) Comisaria Novena - Diag. Sarmiento y Urquiza",
  //     "coordenadas1": "-31.653.427",
  //     "coordenadas2": "-68,279,424",
  //     "tel": "0264 4961040",
  //     "localidad": "Caucete"
  //   },
  //   {
  //     "id": "9",
  //     "dependencia": "Comisaria 10° 25 de Mayo",
  //     "domicilio": "Cría. Décima - Dlio. Ramon Barrera 209 V° Sta Rosa",
  //     "coordenadas1": "-31.744.932",
  //     "coordenadas2": "-68,315,272",
  //     "tel": "0264 4978003",
  //     "localidad": "25 de Mayo"
  //   },
  //   {
  //     "id": "10",
  //     "dependencia": "Comisaria 11° 9 de Julio",
  //     "domicilio": "Cría. Décimo Primera - Diagon. San Martín 7179 (o)",
  //     "coordenadas1": "-31.669.507",
  //     "coordenadas2": "-68,389,391",
  //     "tel": "0264 4977010",
  //     "localidad": "9 de Julio"
  //   },
  //   {
  //     "id": "11",
  //     "dependencia": "Comisaria 12° Valle Fértil",
  //     "domicilio": "Comisaria 12° Dpto. Valle Fértil Calle Rivadavia s/n|",
  //     "coordenadas1": "-30.633.977",
  //     "coordenadas2": "-67,467,278",
  //     "tel": "02646 420100",
  //     "localidad": "Valle Fértil"
  //   },
  //   {
  //     "id": "12",
  //     "dependencia": "Comisaria 13° Rivadavia",
  //     "domicilio": "(*) Comisaria Décimo Tercera - Av. San Martín 7179 Oeste",
  //     "coordenadas1": "-31.530.812",
  //     "coordenadas2": "-68,595,188",
  //     "tel": "0264 4330898",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "13",
  //     "dependencia": "Comisaria 14° Zonda",
  //     "domicilio": "(*) Cría Décimo Cuarta - Dpto. Zonda Ruta 12 Km. 24",
  //     "coordenadas1": "-31.551.552",
  //     "coordenadas2": "-68,730,890",
  //     "tel": "0264 4945002",
  //     "localidad": "Zonda"
  //   },
  //   {
  //     "id": "14",
  //     "dependencia": "Comisaria 15° Ullum",
  //     "domicilio": "(*) Cría Décimo Quinta Dpto. Ullum - Calle Valentin Ruiz s/n°",
  //     "coordenadas1": "-31.460.323",
  //     "coordenadas2": "-68,722,777",
  //     "tel": "0264 4943104",
  //     "localidad": "Ullum"
  //   },
  //   {
  //     "id": "15",
  //     "dependencia": "Comisaria 16° Calingasta",
  //     "domicilio": "Comisaria 16° Dpto. Calingasta: Av.Argentina s/n°",
  //     "coordenadas1": "-31.335.207",
  //     "coordenadas2": "-69,420,937",
  //     "tel": "02648 421022",
  //     "localidad": "Calingasta"
  //   },
  //   {
  //     "id": "16",
  //     "dependencia": "Comisaria 17° Chimbas",
  //     "domicilio": "(*) Comisaria Décimo Séptima - Calle San Martín Este S/N",
  //     "coordenadas1": "-31.492.997",
  //     "coordenadas2": "-68,533,288",
  //     "tel": "0264 4313170",
  //     "localidad": "Chimbas"
  //   },
  //   {
  //     "id": "17",
  //     "dependencia": "Comisaria 18° Albardón",
  //     "domicilio": "(*) Unidad Regional Oeste - Dlio. Calle Mitre s/n°",
  //     "coordenadas1": "-31.439.555",
  //     "coordenadas2": "-68,521,880",
  //     "tel": "0264 4911695",
  //     "localidad": "Albardón"
  //   },
  //   {
  //     "id": "18",
  //     "dependencia": "Comisaria 19° San Marín",
  //     "domicilio": "Cría Décimo Novena - Sarmiento s/n° San Martin",
  //     "coordenadas1": "-31.517.238",
  //     "coordenadas2": "-68,350,905",
  //     "tel": "0264 4971036",
  //     "localidad": "San Martin"
  //   },
  //   {
  //     "id": "19",
  //     "dependencia": "Comisaria 20° Angaco",
  //     "domicilio": "(*) Cría Vigésima - Santa María de Oro s/n° Angaco",
  //     "coordenadas1": "-30.243.085",
  //     "coordenadas2": "-68,746,479",
  //     "tel": "0264 4972023",
  //     "localidad": "Angaco"
  //   },
  //   {
  //     "id": "20",
  //     "dependencia": "Comisaria 21° Jáchal",
  //     "domicilio": "Comisaria 21° Dpto. Jáchal: General Sarmiento 653",
  //     "coordenadas1": "-30.243.069",
  //     "coordenadas2": "-68,746,242",
  //     "tel": "02647 420090",
  //     "localidad": " Jachal"
  //   },
  //   {
  //     "id": "21",
  //     "dependencia": "Comisaria 22° Iglesia",
  //     "domicilio": "Comisaria 22° Dpto. Iglesia: Calle Libertad Barrio América",
  //     "coordenadas1": "-30.215.561",
  //     "coordenadas2": "-69,142,906",
  //     "tel": "02647 493060",
  //     "localidad": "Rodeo - Iglesia"
  //   },
  //   {
  //     "id": "22",
  //     "dependencia": "Comisaria 23° Rivadavia",
  //     "domicilio": "(*) Cría Vigésima.Tercera - Dlio. Cano Sur y Luna B° Rivad. Norte",
  //     "coordenadas1": "-31.513.049",
  //     "coordenadas2": "-68,582,579",
  //     "tel": "0264 4230961",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "23",
  //     "dependencia": "Comisaria 24° Rawson",
  //     "domicilio": "(*) Cría. Vigésima. Cuarta - Calle Misiones y Tacuarí",
  //     "coordenadas1": "-31.564.185",
  //     "coordenadas2": "-68,537,209",
  //     "tel": "0264 4240241",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "24",
  //     "dependencia": "Comisaria 25° Rawson",
  //     "domicilio": "(*) Cría Vigésima. Quinta - Guayaquil s/n°",
  //     "coordenadas1": "-31.565.389",
  //     "coordenadas2": "-68,559,996",
  //     "tel": "0264 4341720",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "25",
  //     "dependencia": "Comisaria 26° Chimbas",
  //     "domicilio": "(*) Cría Vigésima.Sexta - Dlio. Patagonia Oeste 1601 B° Tamarindos",
  //     "coordenadas1": "-31.507.443",
  //     "coordenadas2": "-68,552,227",
  //     "tel": "0264 4235422",
  //     "localidad": "Chimbas"
  //   },
  //   {
  //     "id": "26",
  //     "dependencia": "Comisaria 27° Rivadavia",
  //     "domicilio": "(*) Cría.Vig.Séptima - Dlio. Paula de Sarmiento Area 5 B° Aramburu",
  //     "coordenadas1": "-31.515.984",
  //     "coordenadas2": "-68,563,487",
  //     "tel": "0264 4239648",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "27",
  //     "dependencia": "Comisaria 28° Rivadavia",
  //     "domicilio": "(*) Comisaria Vigésimo Octava - Tulum S/N antes de E Echeverria",
  //     "coordenadas1": "-31.549.773",
  //     "coordenadas2": "-68,559,925",
  //     "tel": "0264 4340004",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "28",
  //     "dependencia": "Comisaria 29° Santa Lucía",
  //     "domicilio": "(*) Comisaria Vigésimo Novena - Cabildo 969 (n)",
  //     "coordenadas1": "-31.521.765",
  //     "coordenadas2": "-68,500,984",
  //     "tel": "0264 4229566",
  //     "localidad": "Santa Lucía"
  //   },
  //   {
  //     "id": "29",
  //     "dependencia": "Comisaria 30° Rivadavia",
  //     "domicilio": "(*) Av. Benavidez 7500 Oeste",
  //     "coordenadas1": "-31.510.729",
  //     "coordenadas2": "-68,618,940",
  //     "tel": "0264 4231479",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "30",
  //     "dependencia": "Comisaria 31° Las Chacritas",
  //     "domicilio": "(*) Cría Trigésimo Primera - Ruta 20 Km.13",
  //     "coordenadas1": "-31.596.058",
  //     "coordenadas2": "-68,404,858",
  //     "tel": "0264 4252719",
  //     "localidad": "Las Chacritas"
  //   },
  //   {
  //     "id": "31",
  //     "dependencia": "Comisaria 32° Casuarinas",
  //     "domicilio": "(*) Cría. Trigésimo Segunda - Rivadavia s/n°",
  //     "coordenadas1": "-31.810.697",
  //     "coordenadas2": "-68,328,325",
  //     "tel": "0264 4974018",
  //     "localidad": "Las Casuarinas - 25 de Mayo"
  //   },
  //   {
  //     "id": "32",
  //     "dependencia": "Comisaria 33° Barreal",
  //     "domicilio": "Comisaria Trigésimo Tercera Barreal",
  //     "coordenadas1": "-31.643.429",
  //     "coordenadas2": "-69,471,989",
  //     "tel": "02648 441022",
  //     "localidad": "Barreal"
  //   },
  //   {
  //     "id": "33",
  //     "dependencia": "Comisaria 34° Rivadavia",
  //     "domicilio": "B° Laguna, La Bebida, Rivadavia",
  //     "coordenadas1": "-31.549.965",
  //     "coordenadas2": "-68,626,293",
  //     "tel": "0264 156707755",
  //     "localidad": "La Bebida"
  //   },
  //   {
  //     "id": "34",
  //     "dependencia": "Comisaria 35° Rawson",
  //     "domicilio": "B° Valle Grande",
  //     "coordenadas1": "-31.567.950",
  //     "coordenadas2": "-68,598,048",
  //     "tel": "0264-4302431",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "35",
  //     "dependencia": "Comisaria 36° Rawson",
  //     "domicilio": "B° Ejército de los Andes, Balmaceda y Progreso",
  //     "coordenadas1": "-31.584.981",
  //     "coordenadas2": "-68,506,230",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "36",
  //     "dependencia": "Comisaria para la Mujer",
  //     "domicilio": "Tucumán 2292 Sur, B° Edilco",
  //     "coordenadas1": "-31.562.647",
  //     "coordenadas2": "-68,520,099",
  //     "tel": "0264 - 4281589",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "37",
  //     "dependencia": "Sub Cria V° Hipódromo",
  //     "domicilio": "Av. Paula A. de Sarmiento y Tumbes",
  //     "coordenadas1": "-31.567.859",
  //     "coordenadas2": "-68,548,430",
  //     "tel": "0264-4344179",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "38",
  //     "dependencia": "Sub Cria Ansilta",
  //     "domicilio": "B° Ansilta",
  //     "coordenadas1": "-31.569.248",
  //     "coordenadas2": "-68,574,280",
  //     "tel": "0264--4383125",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "39",
  //     "dependencia": "Sub Cria Médano de Oro",
  //     "domicilio": "v° Bolaños Calle Manuel Estada, Médano de Oro",
  //     "coordenadas1": "-31.629.434",
  //     "coordenadas2": "-68,481,566",
  //     "tel": "0264-4215859",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "40",
  //     "dependencia": "Sub Cria Castro - Carpinteria",
  //     "domicilio": "B° Chubut S/N",
  //     "coordenadas1": "-31.820.194",
  //     "coordenadas2": "-68,541,865",
  //     "tel": "0264 - 4947005",
  //     "localidad": "Pocito"
  //   },
  //   {
  //     "id": "41",
  //     "dependencia": "Sub Cria V° Mercedes",
  //     "domicilio": "sin datos",
  //     "coordenadas1": "-30.108.418",
  //     "coordenadas2": "-68,702,108",
  //     "tel": "02647 - 492050",
  //     "localidad": "Jachal"
  //   },
  //   {
  //     "id": "42",
  //     "dependencia": "Sub Cria Sta Lucía Este",
  //     "domicilio": "B° Noroeste III",
  //     "coordenadas1": "-31.505.867",
  //     "coordenadas2": "-68,500,919",
  //     "tel": "0264 - 154182720",
  //     "localidad": "Santa Lucía"
  //   },
  //   {
  //     "id": "43",
  //     "dependencia": "Sub Cria Mariano Moreno",
  //     "domicilio": "Villa Mariano Moreno",
  //     "coordenadas1": "-31.465.108",
  //     "coordenadas2": "-68,518,034",
  //     "tel": "0264 - 155589409",
  //     "localidad": "Chimbas"
  //   },
  //   {
  //     "id": "44",
  //     "dependencia": "Sub Cria Los Berros",
  //     "domicilio": "Los Berros",
  //     "coordenadas1": "-31.950.609",
  //     "coordenadas2": "-31,950,609",
  //     "tel": "0264 - 4975143 ",
  //     "localidad": "Sarmiento"
  //   },
  //   {
  //     "id": "45",
  //     "dependencia": "Sub Cria Cipolletti",
  //     "domicilio": "B° La Amistad",
  //     "coordenadas1": "-31.496.797",
  //     "coordenadas2": "-68,572,082",
  //     "tel": "0264 - 4383116",
  //     "localidad": "Chimbas"
  //   },
  //   {
  //     "id": "46",
  //     "dependencia": "Departamental N° 1",
  //     "domicilio": "Gral Acha y Agustín Gómez",
  //     "coordenadas1": "-31.552.591",
  //     "coordenadas2": "-68,522,547",
  //     "localidad": "Capital"
  //   },
  //   {
  //     "id": "47",
  //     "dependencia": "Departamental N° 2",
  //     "domicilio": "Calle San Martín Este S/N",
  //     "coordenadas1": "-31.493.011",
  //     "coordenadas2": "-68,533,322",
  //     "localidad": "Chimbas"
  //   },
  //   {
  //     "id": "48",
  //     "dependencia": "Departamental N° 3",
  //     "domicilio": "B° Valle Grande",
  //     "coordenadas1": "-31.567.936",
  //     "coordenadas2": "-68,597,971",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "49",
  //     "dependencia": "Departamental N° 4",
  //     "domicilio": "Gral. Sarmiento 653",
  //     "coordenadas1": "-30.243.068",
  //     "coordenadas2": "-68,746,614",
  //     "localidad": "Jachal"
  //   },
  //   {
  //     "id": "50",
  //     "dependencia": "Departamental N° 5",
  //     "domicilio": "Calle España antes de Calle 6",
  //     "coordenadas1": "-31.596.930",
  //     "coordenadas2": "-68,547,616",
  //     "localidad": "Pocito"
  //   },
  //   {
  //     "id": "51",
  //     "dependencia": "Departamental N° 6",
  //     "domicilio": "Diag Sarmiento y Urquiza",
  //     "coordenadas1": "-31.653.420",
  //     "coordenadas2": "-68,279,372",
  //     "localidad": "Caucete"
  //   },
  //   {
  //     "id": "52",
  //     "dependencia": "Departamental N° 7",
  //     "domicilio": "Av. San Martín 7179 Oeste",
  //     "coordenadas1": "-31.530.870",
  //     "coordenadas2": "-68,595,183",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "53",
  //     "dependencia": "Division Comando Central",
  //     "domicilio": "Calle David Chávez y Av. Circunvalación",
  //     "coordenadas1": "-31.554.202",
  //     "coordenadas2": "-68,517,321",
  //     "tel": "0264 - 4222319",
  //     "localidad": "Capital"
  //   },
  //   {
  //     "id": "54",
  //     "dependencia": "Division Comando Sur",
  //     "domicilio": "Calle España antes de Calle 6",
  //     "coordenadas1": "-31.596.998",
  //     "coordenadas2": "-68,547,546",
  //     "tel": "0264 - 4243353",
  //     "localidad": "Pocito"
  //   },
  //   {
  //     "id": "55",
  //     "dependencia": "Division Comando Urbano",
  //     "domicilio": "Las Heras y 25 de Mayo",
  //     "coordenadas1": "-31.531.479",
  //     "coordenadas2": "-68,538,635",
  //     "tel": "0264 - 4224662",
  //     "localidad": "Capital"
  //   },
  //   {
  //     "id": "56",
  //     "dependencia": "Division Comando Este",
  //     "domicilio": "Ruta Prov 278 y Cristóbal Colón",
  //     "coordenadas1": "-31.669.977",
  //     "coordenadas2": "-68,278,289",
  //     "localidad": "Caucete"
  //   },
  //   {
  //     "id": "57",
  //     "dependencia": "Base Policial La Bebida Rivadavia",
  //     "domicilio": "Ig de la Rosa y Pellegrini",
  //     "coordenadas1": "-31.539.571",
  //     "coordenadas2": "-68,616,334",
  //     "tel": "0264 - 154182873",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "58",
  //     "dependencia": "Base Motorizada N° 1",
  //     "domicilio": "Mary O'Graham y Paraná, B° Cabot",
  //     "coordenadas1": "-31.511.143",
  //     "coordenadas2": "-68,529,447",
  //     "tel": "0264 - 4214030",
  //     "localidad": "Capital"
  //   },
  //   {
  //     "id": "59",
  //     "dependencia": "Base Motorizada N° 2",
  //     "domicilio": "B° La Estación",
  //     "coordenadas1": "-31.579.531",
  //     "coordenadas2": "-68,551,197",
  //     "tel": "0264 - 4343301",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "60",
  //     "dependencia": "Base Motorizada N° 3",
  //     "domicilio": "Guillermo Rawson  - B° Huazihul",
  //     "coordenadas1": "-31.516.441",
  //     "coordenadas2": "-31,516,441",
  //     "tel": "0264 - 4231551",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "61",
  //     "dependencia": "Base Motorizada N° 4",
  //     "domicilio": "Av. Libertador y Soldado Argentino",
  //     "coordenadas1": "-31.522.441",
  //     "coordenadas2": "-68,617,454",
  //     "tel": "0264 - 4333927",
  //     "localidad": "Rivadavia"
  //   },
  //   {
  //     "id": "62",
  //     "dependencia": "Base Motorizada N° 5",
  //     "domicilio": "calle Cipolletti - B° Parque Industrial",
  //     "coordenadas1": "-31.498.284",
  //     "coordenadas2": "-68,565,126",
  //     "tel": "0264 - 4234613",
  //     "localidad": "Chimbas"
  //   },
  //   {
  //     "id": "63",
  //     "dependencia": "Base Motorizada N° 6",
  //     "domicilio": " Necochea y Saul Quiroga - B° Frondizi",
  //     "coordenadas1": "-31.509.673",
  //     "coordenadas2": "-68,509,475",
  //     "tel": "0264 - 4273282",
  //     "localidad": "Santa Lucía"
  //   },
  //   {
  //     "id": "64",
  //     "dependencia": "Unidad Op. Centenario",
  //     "domicilio": "Ruta 40 y Centenario",
  //     "coordenadas1": "-31.478.569",
  //     "coordenadas2": "-68,519,840",
  //     "localidad": "Chimbas"
  //   },
  //   {
  //     "id": "65",
  //     "dependencia": "Bermejo Control",
  //     "domicilio": "Control Policial Bermejo: Ruta 141 Km. 139",
  //     "coordenadas1": "-31.606.679",
  //     "coordenadas2": "-67,646,755",
  //     "tel": "0264 4295991",
  //     "localidad": "Bermejo - Caucete"
  //   },
  //   {
  //     "id": "66",
  //     "dependencia": "Encon Control",
  //     "domicilio": "Control Policial Encón: Ruta 20 Km. 469",
  //     "coordenadas1": "-32.219.709",
  //     "coordenadas2": "-67,789,456",
  //     "tel": "0264 4295992",
  //     "localidad": "25 de Mayo"
  //   },
  //   {
  //     "id": "67",
  //     "dependencia": "San Carlos Control",
  //     "domicilio": "Control Policial San Carlos: Ruta 40 Km. 86",
  //     "coordenadas1": "-32.256.845",
  //     "coordenadas2": "-68,510,978",
  //     "tel": "0264 4295990",
  //     "localidad": "San Carlos - Sarmiento"
  //   },
  //   {
  //     "id": "68",
  //     "dependencia": "Bomberos Capital",
  //     "domicilio": "(*) Bomberos Capital - Mendoza 1902 Norte",
  //     "coordenadas1": "-31.511.328",
  //     "coordenadas2": "-68,531,058",
  //     "tel": "0264 4212787",
  //     "localidad": "San Juan"
  //   },
  //   {
  //     "id": "69",
  //     "dependencia": "Bomberos Rawson",
  //     "domicilio": "(*) Bomberos Rawson - Tierra del Fuego s/n y Rodriguez",
  //     "coordenadas1": "-31.573.509",
  //     "coordenadas2": "-68,528,491",
  //     "tel": "0264 4240519",
  //     "localidad": "Rawson"
  //   },
  //   {
  //     "id": "70",
  //     "dependencia": "Hospital Rawson",
  //     "domicilio": "Hospital Rawson",
  //     "coordenadas1": "-31.540.043",
  //     "coordenadas2": "-68,511,933",
  //     "tel": "0264 4296970",
  //     "localidad": "Capital"
  //   },
  //   {
  //     "id": "71",
  //     "dependencia": "Dirección de Coordinación, Planificación y Control de Seguridad Vial D-7",
  //     "domicilio": "Calle David Chávez y Av. Circunvalación",
  //     "coordenadas1": "-31.554.157",
  //     "coordenadas2": "-68,517,430",
  //     "tel": "0264 4212329",
  //     "localidad": "San Juan"
  //   }],
  dependencias: [
    { id: "54223fa6-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 1ra" },
    { id: "121517a6-ba5e-11e7-b889-bc5ff4cd6758", nombre: "Dependencia_prueba" },
    { id: "a4c3421c-ba5f-11e7-b889-bc5ff4cd6758", nombre: "prueba 2" },
    { id: "542249b3-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 2ra" },
    { id: "54224d72-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 3ra " },
    { id: "54225140-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 4ra " },
    { id: "542254d8-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 5ra" },
    { id: "5422588e-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 6ra" },
    { id: "54225bc3-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 7ra" },
    { id: "54225f26-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 8ra" },
    { id: "54226255-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 9ra" },
    { id: "5422658f-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 10ra" },
    { id: "54226969-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 11ra" },
    { id: "54226ce8-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 12ra" },
    { id: "54227018-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 13ra" },
    { id: "54227359-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 14ra" },
    { id: "542276c6-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 15ra" },
    { id: "54227a27-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 16ra" },
    { id: "54227d55-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 17ra" },
    { id: "5422808a-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 18ra" },
    { id: "542283ec-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 19ra" },
    { id: "54228d0c-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 20ra" },
    { id: "5422905b-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 21ra" },
    { id: "5422939d-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 22ra" },
    { id: "542296de-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 23ra" },
    { id: "54229a53-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 24ra" },
    { id: "54229dc6-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 25ra" },
    { id: "5422a107-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 26ra" },
    { id: "5422a46a-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 27ra" },
    { id: "5422a7e9-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 28ra" },
    { id: "5422ab22-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 29ra" },
    { id: "5422ae64-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 30ra" },
    { id: "5422b1a9-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 31ra" },
    { id: "5422b50e-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 32ra" },
    { id: "5422b84f-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 33ra" },
    { id: "9645db86-f333-11e4-bad6-0090f58f4f32", nombre: "COMISARÍA 34ra" },
    { id: "64ea133e-f508-11e4-a638-0025d318e182", nombre: "ALCAIDÍA DE TRIBUNALES" },
    { id: "7cc85395-ae6a-11e5-be6e-fa163e1d9e34", nombre: "BASE LA BEBIDA" },
    { id: "0ef2d7ee-a044-11e5-be6e-fa163e1d9e34", nombre: "BRIGADA INVESTIGACIONES NORTE" },
    { id: "b649c2f3-9f4f-11e5-be6e-fa163e1d9e34", nombre: "BRIGADA SUR" },
    { id: "e69c8ca2-a423-11e5-be6e-fa163e1d9e34", nombre: "CASILLA BARRIO ARAMBURU" },
    { id: "30ad978f-a424-11e5-be6e-fa163e1d9e34", nombre: "CASILLA BARRIO PROFESIONAL" },
    { id: "13c5f6f9-a424-11e5-be6e-fa163e1d9e34", nombre: "CASILLA VILLA LOURDES" },
    { id: "83fe1c28-a28c-11e5-be6e-fa163e1d9e34", nombre: "CENTRO DE OP. POLICIALES" },
    { id: "b8938c36-f355-11e4-bad6-0090f58f4f32", nombre: "COMANDO URBANO" },
    { id: "f8cfe364-f34a-11e4-bad6-0090f58f4f32", nombre: "COMISARÍA Bra ESCOBAR" },
    { id: "f8c069fe-f34a-11e4-bad6-0090f58f4f32", nombre: "COMISARÍA Bra FOEVA" },
    { id: "6122d04b-f34b-11e4-bad6-0090f58f4f32", nombre: "COMISARÍA DEL MENOR" },
    { id: "f99c6176-f338-11e4-bad6-0090f58f4f32", nombre: "COMISARÍA PARA LA MUJER" },
    {
      id: "ec565a1c-f507-11e4-a638-0025d318e182",
      nombre: "CONTROL AGENCIAS PRIVADAS (AGENCIA DE VIGILANCIA)",
    },
    { id: "311652e0-f50a-11e4-a638-0025d318e182", nombre: "CONTROL POLICIAL BERMEJO" },
    { id: "311658e7-f50a-11e4-a638-0025d318e182", nombre: "CONTROL POLICIAL ENCÓN" },
    { id: "31165df9-f50a-11e4-a638-0025d318e182", nombre: "CONTROL POLICIAL HUACO" },
    { id: "1e3bc6e7-f506-11e4-a638-0025d318e182", nombre: "CONTROL POLICIAL SAN CARLOS" },
    {
      id: "26249809-f509-11e4-a638-0025d318e182",
      nombre: "CUSTODIA SEÑOR GOBERNADOR (CASA DE GOBIERNO)",
    },
    { id: "b893f176-f355-11e4-bad6-0090f58f4f32", nombre: "DEPARTAMENTO DE BOMBEROS" },
    { id: "f969189a-84d2-11e5-8014-0025d318e182", nombre: "DEPARTAMENTO DE PLANEAMIENTO" },
    { id: "a5e5750b-f506-11e4-a638-0025d318e182", nombre: "DEPARTAMENTO DROGAS ILEGALES " },
    { id: "ec565f4a-f507-11e4-a638-0025d318e182", nombre: "DEPÓSITO JUDICIAL (EX CAVIC)" },
    {
      id: "b89431b4-f355-11e4-bad6-0090f58f4f32",
      nombre: "DESTACAMENTO DE BOMBEROS Nra 2 ZONA NORTE  JÁCHAL",
    },
    { id: "b8941bfa-f355-11e4-bad6-0090f58f4f32", nombre: "DESTACAMENTO Nra 1 - BOMBEROS RAWSON" },
    {
      id: "b8942189-f355-11e4-bad6-0090f58f4f32",
      nombre: "DESTACAMENTO Nra 2 - ZONA NORTE  - JÁCHAL",
    },
    { id: "b8942581-f355-11e4-bad6-0090f58f4f32", nombre: "DESTACAMENTO POLICIAL RAWSON" },
    { id: "459f0b77-f50b-11e4-a638-0025d318e182", nombre: "DIRECCIÓN DE INSTITUTOS D-6" },
    { id: "459ef9ca-f50b-11e4-a638-0025d318e182", nombre: "DIRECCIÓN DE INTELIGENCIA D-2" },
    {
      id: "459efe2e-f50b-11e4-a638-0025d318e182",
      nombre: "DIRECCIÓN DE OPERACIONES POLICIALES D-3",
    },
    { id: "459eefb7-f50b-11e4-a638-0025d318e182", nombre: "DIRECCIÓN DE PERSONAL D-1" },
    { id: "459f02b0-f50b-11e4-a638-0025d318e182", nombre: "DIRECCIÓN INSPECCIÓN Y LOGÍASTICA D-4" },
    { id: "459f0716-f50b-11e4-a638-0025d318e182", nombre: "DIRECCIÓN Y COORDINACIÓN JUDICIAL D-5" },
    { id: "9f6583ee-a289-11e5-be6e-fa163e1d9e34", nombre: "DIV. ADMINISTRACIÓN Y RECURSOS" },
    { id: "7f8a8a4d-a045-11e5-be6e-fa163e1d9e34", nombre: "DIV. ANTECEDENTES PERSONALES" },
    { id: "11c1d3e1-a049-11e5-be6e-fa163e1d9e34", nombre: "DIV. ASESORÍA LETRADA" },
    { id: "fc21d703-a048-11e5-be6e-fa163e1d9e34", nombre: "DIV. BANDA DE MÚSICA" },
    { id: "27052623-a049-11e5-be6e-fa163e1d9e34", nombre: "DIV. CANES" },
    { id: "988e545a-a047-11e5-be6e-fa163e1d9e34", nombre: "DIV. COMANDO RAD. SUR" },
    { id: "9932e1e7-a045-11e5-be6e-fa163e1d9e34", nombre: "DIV. COMP. Y ESTADÍASTICA" },
    { id: "a13e71a2-a28b-11e5-be6e-fa163e1d9e34", nombre: "DIV. CONTADURÍA" },
    { id: "be1b8e3e-a28b-11e5-be6e-fa163e1d9e34", nombre: "DIV. CONTADURÍA DE ADICIONALES" },
    { id: "0b91a202-a046-11e5-be6e-fa163e1d9e34", nombre: "DIV. CONTROL PATRIMONIAL" },
    { id: "b816e478-a288-11e5-be6e-fa163e1d9e34", nombre: "DIV. CPO. ESPECIAL DE VIGILANCIA" },
    { id: "5a1de83b-a046-11e5-be6e-fa163e1d9e34", nombre: "DIV. EDIFICIOS E INSTALACIONES FIJAS" },
    { id: "ca48fc55-a049-11e5-be6e-fa163e1d9e34", nombre: "DIV. EXPLOSIVOS" },
    { id: "b8943989-f355-11e4-bad6-0090f58f4f32", nombre: "DIV. GUARDIA DE PREVENCIÓN " },
    { id: "e7cb372e-a039-11e5-be6e-fa163e1d9e34", nombre: "DIV. INFORMÁTICA" },
    { id: "558883f3-a041-11e5-be6e-fa163e1d9e34", nombre: "DIV. INGENIEROS" },
    { id: "c8213eeb-a289-11e5-be6e-fa163e1d9e34", nombre: "DIV. INSTRUCCIÓN Y PROCESO PRELIMINAR" },
    { id: "49351b61-a289-11e5-be6e-fa163e1d9e34", nombre: "DIV. INTELIGENCIA" },
    { id: "3c1f98e8-a046-11e5-be6e-fa163e1d9e34", nombre: "DIV. INTENDENCIA" },
    { id: "63ee63e3-a289-11e5-be6e-fa163e1d9e34", nombre: "DIV. INVESTIGACIÓN  Y OPERACIONES" },
    { id: "e2093448-a049-11e5-be6e-fa163e1d9e34", nombre: "DIV. OPERACIONES" },
    { id: "1424f8dd-a041-11e5-be6e-fa163e1d9e34", nombre: "DIV. POLICÍA ECOLÓGICA" },
    {
      id: "5669ef0a-a045-11e5-be6e-fa163e1d9e34",
      nombre: "DIV. REGISTRO PROVINCIAL DE ARMA REPAR",
    },
    { id: "e29cacae-a048-11e5-be6e-fa163e1d9e34", nombre: "DIV. RELACIONES POLICIALES" },
    { id: "8dc0cf60-a049-11e5-be6e-fa163e1d9e34", nombre: "DIV. REUNIÓN DE LA INFORMACIÓN" },
    { id: "f05e1261-a047-11e5-be6e-fa163e1d9e34", nombre: "DIV. SANIDAD POLICIAL" },
    { id: "d11678a4-a28c-11e5-be6e-fa163e1d9e34", nombre: "DIV. SEGURIDAD BANCARIA" },
    { id: "a539e010-a049-11e5-be6e-fa163e1d9e34", nombre: "DIV. SINIESTROS" },
    { id: "006a9c57-a28d-11e5-be6e-fa163e1d9e34", nombre: "DIV. TELECOMUNICACIONES" },
    { id: "84adf9f6-a28b-11e5-be6e-fa163e1d9e34", nombre: "DIV. TESORERÍA" },
    { id: "878c17a9-a033-11e5-be6e-fa163e1d9e34", nombre: "DIV. TRÁNSITO" },
    { id: "7a8ff8b8-8a13-11e5-824d-0025d318e182", nombre: "DIVISION CRIMINALISTICA" },
    { id: "9f315e4e-8a13-11e5-824d-0025d318e182", nombre: "DIVISION DELITOS" },
    { id: "b4dc622d-8ec5-11e5-abe9-0025d318e182", nombre: "DIVISION SERVICIOS ESPECIALES" },
    { id: "b8944981-f355-11e4-bad6-0090f58f4f32", nombre: "DIVISIÓN ARMAMENTO" },
    { id: "ec565517-f507-11e4-a638-0025d318e182", nombre: "DIVISIÓN AUTOMOTORES" },
    { id: "b89441a5-f355-11e4-bad6-0090f58f4f32", nombre: "DIVISIÓN BRIGADA FEMENINA" },
    { id: "b893912a-f355-11e4-bad6-0090f58f4f32", nombre: "DIVISIÓN COMANDO RADIOELÉCTRICO" },
    { id: "067f5b18-a28b-11e5-be6e-fa163e1d9e34", nombre: "DIVISIÓN CONVENIO POLICIAL" },
    {
      id: "b8943590-f355-11e4-bad6-0090f58f4f32",
      nombre: "DIVISIÓN CUERPO ESPECIAL DE VIGILANCIA",
    },
    { id: "d162ac2e-a355-11e5-be6e-fa163e1d9e34", nombre: "DIVISIÓN DELITOS COMPLEJOS" },
    { id: "b894297e-f355-11e4-bad6-0090f58f4f32", nombre: "DIVISIÓN INFANTERÍA" },
    { id: "ec563f58-f507-11e4-a638-0025d318e182", nombre: "DIVISIÓN PREVISIÓN SOCIAL" },
    { id: "ec564fc9-f507-11e4-a638-0025d318e182", nombre: "DIVISIÓN SERVICIOS SOCIALES" },
    { id: "44fca3b8-a28c-11e5-be6e-fa163e1d9e34", nombre: "DPTO COMUNICACIONES" },
    { id: "49350337-a049-11e5-be6e-fa163e1d9e34", nombre: "DPTO DE COORDINACIÓN " },
    { id: "dce68343-a032-11e5-be6e-fa163e1d9e34", nombre: "DPTO OPERACIONES ESPECIALES" },
    { id: "c36b3510-a28a-11e5-be6e-fa163e1d9e34", nombre: "DPTO SECRETARÍA GENERAL" },
    { id: "ad4ce270-a02b-11e5-be6e-fa163e1d9e34", nombre: "DPTO SERVICIOS SOCIALES" },
    { id: "617609e3-a28b-11e5-be6e-fa163e1d9e34", nombre: "DPTO. ADMINISTRACIÓN" },
    { id: "c52f5d13-a02b-11e5-be6e-fa163e1d9e34", nombre: "DPTO. ADMINISTRACIÓN DE PERSONAL" },
    { id: "94536def-9f62-11e5-be6e-fa163e1d9e34", nombre: "DPTO. ASUNTOS JUDICIALES D-5" },
    { id: "8c6ee7f1-9f61-11e5-be6e-fa163e1d9e34", nombre: "DPTO. COORDINACIÓN DE LA PREVENCIÓN" },
    {
      id: "27a9c2e8-9f69-11e5-be6e-fa163e1d9e34",
      nombre: "DPTO. INSPECCIÓN  Y CONTROL PATRIMONIAL",
    },
    { id: "0da28d7b-9f69-11e5-be6e-fa163e1d9e34", nombre: "DPTO. SERVICIO Y APOYO LOGÍASTICO" },
    {
      id: "ec568101-f507-11e4-a638-0025d318e182",
      nombre: "EDIFICIO NUEVO DE LA PLANTA VERIFICADORA",
    },
    { id: "0562771c-f507-11e4-a638-0025d318e182", nombre: "ESCUELA DE CADETES" },
    { id: "2a4a2204-a02d-11e5-be6e-fa163e1d9e34", nombre: "ESCUELA DE SUBOFICIALES Y AGENTES" },
    { id: "3c52044e-a02d-11e5-be6e-fa163e1d9e34", nombre: "ESCUELA SUPERIOR" },
    { id: "cdc70f1e-a288-11e5-be6e-fa163e1d9e34", nombre: "G.A.M." },
    { id: "8d2b2176-a288-11e5-be6e-fa163e1d9e34", nombre: "G.E.R.A.S." },
    { id: "de1a4d2b-ae6a-11e5-be6e-fa163e1d9e34", nombre: "GRUPO DE CONTENCIÓN" },
    { id: "21998074-f505-11e4-a638-0025d318e182", nombre: "GUARDIA LEGISLATURA PROVINCIAL" },
    { id: "b4dc6202-8ec5-11e5-abe9-0025d318e182", nombre: "JEFATURA" },
    { id: "b8942dbf-f355-11e4-bad6-0090f58f4f32", nombre: "MÓVILES COMUNALES" },
    { id: "0e2206c6-a338-11e5-be6e-fa163e1d9e34", nombre: "MÓVILES COMUNALES (CAPITAL)" },
    { id: "258a22f2-a338-11e5-be6e-fa163e1d9e34", nombre: "MÓVILES COMUNALES (STA. LUCIA)" },
    { id: "820bb217-a338-11e5-be6e-fa163e1d9e34", nombre: "MÓVILES COMUNALES - POCITO" },
    { id: "6c949beb-a338-11e5-be6e-fa163e1d9e34", nombre: "MÓVILES COMUNALES - RAWSON" },
    { id: "3ba31a97-a338-11e5-be6e-fa163e1d9e34", nombre: "MÓVILES COMUNALES DE CHIMBAS" },
    { id: "526fa754-a338-11e5-be6e-fa163e1d9e34", nombre: "MÓVILES COMUNALES DE RIVADAVIA" },
    { id: "381fdc66-a28b-11e5-be6e-fa163e1d9e34", nombre: "OFICINA DE A.R.T." },
    { id: "5feb7b59-a043-11e5-be6e-fa163e1d9e34", nombre: "POLICÍA RURAL VILLA INDEPENDENCIA" },
    { id: "1d538f17-a28d-11e5-be6e-fa163e1d9e34", nombre: "PROGRAMACIÓN Y SERVICIOS TÉCNICOS" },
    { id: "b893ddf3-f355-11e4-bad6-0090f58f4f32", nombre: "PUESTO NIQUIVIL" },
    { id: "219f15e7-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL ANGUALASTO" },
    { id: "219f0481-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL BALCARCE" },
    { id: "219f0006-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL BARRIO SAN MARTIN" },
    {
      id: "219efa06-f505-11e4-a638-0025d318e182",
      nombre: "PUESTO POLICIAL GUARDIA HOSPITAL RAWSON",
    },
    { id: "219f11e7-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL IGLESIA" },
    { id: "219f19d6-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL LAS FLORES" },
    { id: "219f0dda-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL MOGNA" },
    { id: "219f27cd-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL PUCHUZUM" },
    { id: "219f2fd2-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL SAN ROQUE" },
    { id: "219f2bde-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL TAMBERIAS" },
    { id: "219f239a-f505-11e4-a638-0025d318e182", nombre: "PUESTO POLICIAL TUDCUM" },
    { id: "98b2caad-a28c-11e5-be6e-fa163e1d9e34", nombre: "RED. NAC. TELECOM" },
    {
      id: "ec5664c7-f507-11e4-a638-0025d318e182",
      nombre: "REGISTRO PROVINCIAL DE EXP. DE BEBIDAS ALCOHÓLICAS (BOMBEROS)",
    },
    { id: "f239e51e-a28b-11e5-be6e-fa163e1d9e34", nombre: "SE.PRO.MI." },
    { id: "5422c5d9-9cae-11e4-94c2-0025d318e182", nombre: "SEC. DEFRAUDACION Y ESTAFA" },
    { id: "5422f674-9cae-11e4-94c2-0025d318e182", nombre: "SEC. LEYES ESPECIALES" },
    { id: "5422c271-9cae-11e4-94c2-0025d318e182", nombre: "SEC. ROBOS Y HURTOS" },
    { id: "22712d64-a28b-11e5-be6e-fa163e1d9e34", nombre: "SECCIÓN ARCHIVO SECTORIAL" },
    {
      id: "b8939e4a-f355-11e4-bad6-0090f58f4f32",
      nombre: "SECCIÓN BRIGADA MOTORIZADA Nra 1 - CONCEPCIÓN",
    },
    {
      id: "b893b378-f355-11e4-bad6-0090f58f4f32",
      nombre: "SECCIÓN BRIGADA MOTORIZADA Nra 2 - RAWSON",
    },
    {
      id: "b893b8b3-f355-11e4-bad6-0090f58f4f32",
      nombre: "SECCIÓN BRIGADA MOTORIZADA Nra 3 - BARRIO HUAZIHUL",
    },
    {
      id: "b893bce7-f355-11e4-bad6-0090f58f4f32",
      nombre: "SECCIÓN BRIGADA MOTORIZADA Nra 4 - RIVADAVIA",
    },
    {
      id: "b893c103-f355-11e4-bad6-0090f58f4f32",
      nombre: "SECCIÓN BRIGADA MOTORIZADA Nra 5 - CHIMBAS",
    },
    {
      id: "b893c52b-f355-11e4-bad6-0090f58f4f32",
      nombre: "SECCIÓN BRIGADA MOTORIZADA Nra 6 - BARRIO FRONDIZI",
    },
    {
      id: "4ee76319-a28d-11e5-be6e-fa163e1d9e34",
      nombre: "SECCIÓN DE COORDINACIÓN DE BÚSQUEDA Y RESCATE DE PERSONAS",
    },
    { id: "726e9ef8-a046-11e5-be6e-fa163e1d9e34", nombre: "SECCIÓN DOCUMENTACIÓN Y SEGURO" },
    { id: "5422e25d-9cae-11e4-94c2-0025d318e182", nombre: "SECCIÓN HOMICIDIOS" },
    { id: "7b29ea70-f509-11e4-a638-0025d318e182", nombre: "SECCIÓN INTELIGENCIA CRIMINAL" },
    { id: "0dd2173f-a048-11e5-be6e-fa163e1d9e34", nombre: "SECCIÓN LEGAJO PERSONAL" },
    { id: "f146073e-a28a-11e5-be6e-fa163e1d9e34", nombre: "SECCIÓN MESA GENERAL DE ENTRADA" },
    { id: "70f24ee9-a28d-11e5-be6e-fa163e1d9e34", nombre: "SECCIÓN MOTORIZADA 2" },
    { id: "d1520e26-a28b-11e5-be6e-fa163e1d9e34", nombre: "SECCIÓN SALARIO FAMILIAR" },
    { id: "4d0c6279-a03d-11e5-9670-0025d318e182", nombre: "SECCIÓN SEGURIDAD PERSONAL" },
    {
      id: "6576319c-a28c-11e5-be6e-fa163e1d9e34",
      nombre: "SECCIÓN SUPERVISIÓN Y ADMINISTRACIÓN DE LA PREVENCIÓN",
    },
    {
      id: "5422bb91-9cae-11e4-94c2-0025d318e182",
      nombre: 'SUBCOMISARÍA - "OF. INSP. CARLOS MARCELINO CASTRO"  CARPINTERÍA',
    },
    {
      id: "5422e5d8-9cae-11e4-94c2-0025d318e182",
      nombre: 'SUBCOMISARÍA - "OF. INSP. JOSÉ ÁNGEL SORIA" - LOS BERROS',
    },
    { id: "5422ec80-9cae-11e4-94c2-0025d318e182", nombre: "SUBCOMISARÍA - BARRIO ANSILTA" },
    { id: "5422bef4-9cae-11e4-94c2-0025d318e182", nombre: "SUBCOMISARÍA - MÉDANO DE ORO" },
    { id: "5422f338-9cae-11e4-94c2-0025d318e182", nombre: "SUBCOMISARÍA - SANTA LUCIA ESTE" },
    { id: "5422e944-9cae-11e4-94c2-0025d318e182", nombre: "SUBCOMISARÍA - VILLA HIPÓDROMO" },
    { id: "5422dbb0-9cae-11e4-94c2-0025d318e182", nombre: "SUBCOMISARÍA - VILLA MERCEDES" },
    { id: "5422efbf-9cae-11e4-94c2-0025d318e182", nombre: "SUBCOMISARÍA BARRIO CIPOLLETI " },
    { id: "b4dc6221-8ec5-11e5-abe9-0025d318e182", nombre: "SUBJEFATURA" },
    { id: "cad7d70f-f509-11e4-a638-0025d318e182", nombre: "SUBSECRETARÍA CONTROL DE GESTIÓN" },
    { id: "5422c918-9cae-11e4-94c2-0025d318e182", nombre: "TOXICOMANIA" },
    { id: "73231ba3-a049-11e5-be6e-fa163e1d9e34", nombre: "UNIDAD DE COORDINACIÓN COMUNAL" },
    { id: "5422def7-9cae-11e4-94c2-0025d318e182", nombre: "UNIDAD JUDICIAL Nra1" },
    { id: "9251f552-a28d-11e5-be6e-fa163e1d9e34", nombre: "UNIDAD MOT. DE ACC. RÁPIDA" },
    { id: "b893d5ff-f355-11e4-bad6-0090f58f4f32", nombre: "UNIDAD OPERATIVA ANSILTA" },
    {
      id: "b893ce8e-f355-11e4-bad6-0090f58f4f32",
      nombre: "UNIDAD OPERATIVA BARRIO TERESA DE CALCUTA",
    },
    { id: "b893ca79-f355-11e4-bad6-0090f58f4f32", nombre: "UNIDAD OPERATIVA CENTRO CÍAVICO" },
    {
      id: "b893d240-f355-11e4-bad6-0090f58f4f32",
      nombre: "UNIDAD OPERATIVA CHIMBAS SUR (SEGURIDAD COMUNITARIA)",
    },
    { id: "b893e9bf-f355-11e4-bad6-0090f58f4f32", nombre: "UNIDAD OPERATIVA MARIANO MORENO" },
    { id: "b893826b-f355-11e4-bad6-0090f58f4f32", nombre: "UNIDAD OPERATIVA POCITO NORTE" },
    { id: "c968a3f1-ae6b-11e5-be6e-fa163e1d9e34", nombre: "UNIDAD OPERATIVA QUINTO CUARTEL" },
    { id: "b893da0e-f355-11e4-bad6-0090f58f4f32", nombre: "UNIDAD OPERATIVA TAMBERÍAS" },
    { id: "b893e1c6-f355-11e4-bad6-0090f58f4f32", nombre: "UNIDAD POLICIAL LA RINCONADA POCITO" },
    {
      id: "b893edae-f355-11e4-bad6-0090f58f4f32",
      nombre: "UNIDAD POLICIAL Nra 1 PTE. NÉSTOR KIRCHNER",
    },
    { id: "dee5f460-deb4-11e4-89a4-0090f58f4f32", nombre: "UNIDAD REGIONAL CAPITAL" },
    { id: "df0d8df4-deb4-11e4-89a4-0090f58f4f32", nombre: "UNIDAD REGIONAL ESTE" },
    { id: "df19b63c-deb4-11e4-89a4-0090f58f4f32", nombre: "UNIDAD REGIONAL NOROESTE" },
    { id: "df017898-deb4-11e4-89a4-0090f58f4f32", nombre: "UNIDAD REGIONAL OESTE" },
    { id: "def56d11-deb4-11e4-89a4-0090f58f4f32", nombre: "UNIDAD REGIONAL SUR" },
    { id: "219f08fb-f505-11e4-a638-0025d318e182", nombre: "UNIDAD RURAL  ALBARDÓN" },
    { id: "b893e5a3-f355-11e4-bad6-0090f58f4f32", nombre: "UNIDAD RURAL Nra 1 (DIFUNTA CORREA)" },
    { id: "1c5a109c-522c-4979-a0a7-25d8e858a78f", nombre: "COMISARIA 99ra" },
  ],

  modusoperandi: [
    { id: "50305082-41bb-11e5-9749-0025d318e182", nombre: "-" },
    { id: "eb8e1ef2-b889-11e4-80cf-0025d318e182", nombre: "ABORTO" },
    { id: "eb9b42d2-b889-11e4-80cf-0025d318e182", nombre: "ABUSO SEXUAL" },
    { id: "ebb3227d-b889-11e4-80cf-0025d318e182", nombre: "ACCESO CARNAL" },
    { id: "46b40144-a28f-11e5-8dff-0090f58f4f32", nombre: "ACCIDENTE DE TRANSITO" },
    { id: "ebc1f1ea-b889-11e4-80cf-0025d318e182", nombre: "AHORCAMIENTO" },
    { id: "46b40169-a28f-11e5-8dff-0090f58f4f32", nombre: "ALLANAMIENTO" },
    { id: "ebcc6ee3-b889-11e4-80cf-0025d318e182", nombre: "AMENAZAS" },
    { id: "ebd6e7dd-b889-11e4-80cf-0025d318e182", nombre: "ARREBATO" },
    { id: "ebe25210-b889-11e4-80cf-0025d318e182", nombre: "ARROJO PIEDRA" },
    { id: "ebf746e6-b889-11e4-80cf-0025d318e182", nombre: "ASALTO C/ARMA BLANCA" },
    { id: "ec0ccadb-b889-11e4-80cf-0025d318e182", nombre: "ASALTO C/ARMA DE FUEGO" },
    { id: "ec1897ea-b889-11e4-80cf-0025d318e182", nombre: "ASALTO C/VIOLENCIAS" },
    { id: "ec01b6d7-b889-11e4-80cf-0025d318e182", nombre: "ASALTO E/CONTUNDENTE" },
    { id: "ebecaad0-b889-11e4-80cf-0025d318e182", nombre: "ASALTO M/ARMADA" },
    { id: "ec2526ce-b889-11e4-80cf-0025d318e182", nombre: "CUATREROS" },
    { id: "ec2f46d9-b889-11e4-80cf-0025d318e182", nombre: "CUENTO DEL TIO" },
    { id: "ec3b409f-b889-11e4-80cf-0025d318e182", nombre: "DAÑO" },
    { id: "ec458476-b889-11e4-80cf-0025d318e182", nombre: "EN BANDA" },
    { id: "ec52dc45-b889-11e4-80cf-0025d318e182", nombre: "ESCALAMIENTO" },
    { id: "ec5d3c7b-b889-11e4-80cf-0025d318e182", nombre: "EXHIBICIONES OBSCENAS" },
    { id: "ec6734bc-b889-11e4-80cf-0025d318e182", nombre: "IN FRAGANTI" },
    { id: "ec765f79-b889-11e4-80cf-0025d318e182", nombre: "INGESTA MEDICAMENTOSA" },
    { id: "ec81c0a7-b889-11e4-80cf-0025d318e182", nombre: "INGESTA S/TOXICA" },
    { id: "ec8d021f-b889-11e4-80cf-0025d318e182", nombre: "INGRESO S/VIOLENCIA" },
    { id: "46b40175-a28f-11e5-8dff-0090f58f4f32", nombre: "INMERCION" },
    { id: "ec9a1610-b889-11e4-80cf-0025d318e182", nombre: "LESIONES" },
    { id: "eca44de7-b889-11e4-80cf-0025d318e182", nombre: "LLAVE FALSA O GANZUA" },
    { id: "ecae9434-b889-11e4-80cf-0025d318e182", nombre: "MANOSEO" },
    { id: "ecbceb64-b889-11e4-80cf-0025d318e182", nombre: "MECHERA" },
    { id: "ecc707b6-b889-11e4-80cf-0025d318e182", nombre: "OPORTUNISTA" },
    { id: "ecd33640-b889-11e4-80cf-0025d318e182", nombre: "OTROS" },
    { id: "ecdd506d-b889-11e4-80cf-0025d318e182", nombre: "PEDIDO DE SECUESTRO" },
    { id: "ece756d9-b889-11e4-80cf-0025d318e182", nombre: "PUNGUISTA" },
    { id: "ecf35ea3-b889-11e4-80cf-0025d318e182", nombre: "ROBO C/FZA FISICA" },
    { id: "ed089762-b889-11e4-80cf-0025d318e182", nombre: "ROTURA CANDADO" },
    { id: "ed179f4f-b889-11e4-80cf-0025d318e182", nombre: "ROTURA CERRADURA" },
    { id: "ed76c120-b889-11e4-80cf-0025d318e182", nombre: "ROTURA PERIMETRO" },
    { id: "ed22290d-b889-11e4-80cf-0025d318e182", nombre: "ROTURA PUERTA" },
    { id: "ed2d329d-b889-11e4-80cf-0025d318e182", nombre: "ROTURA PUERTA AUTO" },
    { id: "ed3b5911-b889-11e4-80cf-0025d318e182", nombre: "ROTURA TECHO" },
    { id: "ed44f293-b889-11e4-80cf-0025d318e182", nombre: "ROTURA VENTANA" },
    { id: "ed528534-b889-11e4-80cf-0025d318e182", nombre: "ROTURA VIDRIERA" },
    { id: "ed5e33b3-b889-11e4-80cf-0025d318e182", nombre: "ROTURA VIDRIO   " },
    { id: "ed6886a3-b889-11e4-80cf-0025d318e182", nombre: "ROTURA VIDRIO AUTO" },
    { id: "ecfd742a-b889-11e4-80cf-0025d318e182", nombre: "ROTURA VIDRIO MOVIL POLICIAL " },
    { id: "ed97ff73-b889-11e4-80cf-0025d318e182", nombre: "ROTURA/VIOLENCIA" },
    { id: "46b4017e-a28f-11e5-8dff-0090f58f4f32", nombre: "ROTURAS DE PERIMETRO" },
    { id: "ed80f73c-b889-11e4-80cf-0025d318e182", nombre: "ROTURAS VARIAS" },
    { id: "ed8ad032-b889-11e4-80cf-0025d318e182", nombre: "SIN ESPECIFICAR" },
    { id: "46b40187-a28f-11e5-8dff-0090f58f4f32", nombre: "SIN VIOLENCIA" },
    { id: "eda2aab6-b889-11e4-80cf-0025d318e182", nombre: "USO TIJERA Y OTROS" },
    { id: "edad30ee-b889-11e4-80cf-0025d318e182", nombre: "VIA CARTA O NOTA" },
    { id: "edc5a1ac-b889-11e4-80cf-0025d318e182", nombre: "VIA INTERNET (RED SOCIAL, ETC)" },
    { id: "edbb88e0-b889-11e4-80cf-0025d318e182", nombre: "VIA TELEFONICA" },
    { id: "edd1a301-b889-11e4-80cf-0025d318e182", nombre: "VIOLACION DE DOCUMENTACION" },
  ],

  fiscalias: [],

  orientacion: [
    { id: "ESTE", nombre: "ESTE" },
    { id: "NORTE", nombre: "NORTE" },
    { id: "OESTE", nombre: "OESTE" },
    { id: "SUR", nombre: "SUR" },
  ],

  departamentos: [
    { id: "7d167406-dc7f-4edd-b5e9-fa4121d3eb6e", nombre: "Sin Departamento" },
    { id: "71c04abf-ce2d-11e4-a042-0090f58f4f32", nombre: "25 DE MAYO" },
    { id: "7164a28a-ce2d-11e4-a042-0090f58f4f32", nombre: "9 DE JULIO" },
    { id: "7115dec8-ce2d-11e4-a042-0090f58f4f32", nombre: "ALBARDON" },
    { id: "7123cb1b-ce2d-11e4-a042-0090f58f4f32", nombre: "ANGACO" },
    { id: "712e0fb6-ce2d-11e4-a042-0090f58f4f32", nombre: "CALINGASTA" },
    { id: "9536aa48-b0a5-11e4-9ace-0025d318e182", nombre: "CAPITAL" },
    { id: "71385581-ce2d-11e4-a042-0090f58f4f32", nombre: "CAUCETE" },
    { id: "71444675-ce2d-11e4-a042-0090f58f4f32", nombre: "CHIMBAS" },
    { id: "714e85c8-ce2d-11e4-a042-0090f58f4f32", nombre: "IGLESIA" },
    { id: "7158ca33-ce2d-11e4-a042-0090f58f4f32", nombre: "JACHAL" },
    { id: "716ed4c6-ce2d-11e4-a042-0090f58f4f32", nombre: "POCITO" },
    { id: "47f273e2-9cc0-11e4-94c2-0025d318e182", nombre: "RAWSON" },
    { id: "71791441-ce2d-11e4-a042-0090f58f4f32", nombre: "RIVADAVIA" },
    { id: "7184de06-ce2d-11e4-a042-0090f58f4f32", nombre: "SAN MARTIN" },
    { id: "718f0e5f-ce2d-11e4-a042-0090f58f4f32", nombre: "SANTA LUCIA" },
    { id: "71a00fb5-ce2d-11e4-a042-0090f58f4f32", nombre: "SARMIENTO" },
    { id: "71aa93f2-ce2d-11e4-a042-0090f58f4f32", nombre: "ULLUM" },
    { id: "71b51e9b-ce2d-11e4-a042-0090f58f4f32", nombre: "VALLE FERTIL" },
    { id: "71caaf12-ce2d-11e4-a042-0090f58f4f32", nombre: "ZONDA" },
  ],

  causas: [
    { id: "1aed445d-b88c-11e4-80cf-0025d318e182", nombre: "ABIGEATO" },
    { id: "1b0021fa-b88c-11e4-80cf-0025d318e182", nombre: "ABORTO" },
    { id: "1b0c06e4-b88c-11e4-80cf-0025d318e182", nombre: "ABUSO DE ARMA" },
    { id: "1b245f22-b88c-11e4-80cf-0025d318e182", nombre: "ACT. DESAP. DE PERSONA" },
    { id: "2023790c-b88c-11e4-80cf-0025d318e182", nombre: "ACT.PARA ESTABLECER PARADERO" },
    { id: "1b30b47c-b88c-11e4-80cf-0025d318e182", nombre: "ACT.POR FALLECIMIENTO" },
    { id: "1b4941e9-b88c-11e4-80cf-0025d318e182", nombre: "ACTUACIONES POR FUGA DE HOGAR" },
    { id: "202f67cc-b88c-11e4-80cf-0025d318e182", nombre: "ALLANAMIENTO" },
    { id: "2072b35b-b88c-11e4-80cf-0025d318e182", nombre: "AMENAZAS" },
    { id: "1b55337f-b88c-11e4-80cf-0025d318e182", nombre: "AMPLIACION DE SUMARIO" },
    { id: "1b611856-b88c-11e4-80cf-0025d318e182", nombre: "APREMIOS ILEGALES" },
    { id: "1b6d1a64-b88c-11e4-80cf-0025d318e182", nombre: "ATENT. Y RESIS. AUTORIDAD" },
    { id: "1b793d39-b88c-11e4-80cf-0025d318e182", nombre: "C/INT. SEXUAL" },
    { id: "1b85823a-b88c-11e4-80cf-0025d318e182", nombre: "CIGARRILOS CLANDESTINOS" },
    { id: "1b9427b0-b88c-11e4-80cf-0025d318e182", nombre: "COACCION" },
    { id: "1b9fec57-b88c-11e4-80cf-0025d318e182", nombre: "COHECHO" },
    { id: "1babee81-b88c-11e4-80cf-0025d318e182", nombre: "CORRUPCION" },
    { id: "1bb7c1a6-b88c-11e4-80cf-0025d318e182", nombre: "CORRUPCION DE MENORES" },
    { id: "1bc40be7-b88c-11e4-80cf-0025d318e182", nombre: "DAÑO" },
    { id: "1bd1c970-b88c-11e4-80cf-0025d318e182", nombre: "DEFRAUDACION" },
    { id: "1bded1a7-b88c-11e4-80cf-0025d318e182", nombre: "DELIT.C.HONESTIDAD" },
    { id: "1bead4f5-b88c-11e4-80cf-0025d318e182", nombre: "DELITO C/ SALUD PUBLICA" },
    { id: "1bf68399-b88c-11e4-80cf-0025d318e182", nombre: "DELITO C/SEGURIDAD PUBLICA" },
    { id: "1c02b9ba-b88c-11e4-80cf-0025d318e182", nombre: "DELITOS C/ESTADO CIVIL" },
    { id: "219b13a7-b88c-11e4-80cf-0025d318e182", nombre: "DEPOSITO" },
    { id: "203bc643-b88c-11e4-80cf-0025d318e182", nombre: "DESOBEDIENCIA  OFICIO JUDICIAL" },
    { id: "1c0e97f9-b88c-11e4-80cf-0025d318e182", nombre: "DEST DE DOC PUBLICO" },
    { id: "1c1b1339-b88c-11e4-80cf-0025d318e182", nombre: "E./CHEQUE SIN FONDO" },
    { id: "1c2997b4-b88c-11e4-80cf-0025d318e182", nombre: "ENCUBRIMIENTO" },
    { id: "1c35b7ab-b88c-11e4-80cf-0025d318e182", nombre: "ESTAFA" },
    { id: "1c42ea6a-b88c-11e4-80cf-0025d318e182", nombre: "ESTAFA ATENUADA" },
    { id: "1c4f0a67-b88c-11e4-80cf-0025d318e182", nombre: "ESTUPRO" },
    { id: "1c5b9834-b88c-11e4-80cf-0025d318e182", nombre: "EVASION" },
    { id: "1c684cdc-b88c-11e4-80cf-0025d318e182", nombre: "EXACCIONES ILEGALES" },
    { id: "1c746fc2-b88c-11e4-80cf-0025d318e182", nombre: "EXHIBICIONES OBSCENAS" },
    { id: "1c865916-b88c-11e4-80cf-0025d318e182", nombre: "EXTORSION" },
    { id: "1c932928-b88c-11e4-80cf-0025d318e182", nombre: "FALLECIMIENTO SIN ASIST." },
    { id: "1cac9f8a-b88c-11e4-80cf-0025d318e182", nombre: "FALS. DE MONEDA" },
    { id: "1cb8a33f-b88c-11e4-80cf-0025d318e182", nombre: "FALS. DOC. PUBLICO" },
    { id: "1cc83d97-b88c-11e4-80cf-0025d318e182", nombre: "FALSA DENUNCIA" },
    { id: "1c9f72d2-b88c-11e4-80cf-0025d318e182", nombre: "FALSIFICACIÓN" },
    { id: "21c36d58-b88c-11e4-80cf-0025d318e182", nombre: "FALTA AL DEBER FUNC PUB" },
    { id: "1cd55a85-b88c-11e4-80cf-0025d318e182", nombre: "HOMICIDIO ART . 81 ATENUADO" },
    { id: "1ce1370c-b88c-11e4-80cf-0025d318e182", nombre: "HOMICIDIO ART 80" },
    { id: "1ced2f86-b88c-11e4-80cf-0025d318e182", nombre: "HOMICIDIO ART. 79" },
    { id: "1cf8e2fe-b88c-11e4-80cf-0025d318e182", nombre: "HOMICIDIO ART. 80 AGRAVADO" },
    { id: "1d07fb5c-b88c-11e4-80cf-0025d318e182", nombre: "HOMICIDIO ART. 84" },
    { id: "d077978e-f50e-11e4-a638-0025d318e182", nombre: "HOMICIDIO CULPOSO (SIN INTENCIÓN)" },
    { id: "1d13c050-b88c-11e4-80cf-0025d318e182", nombre: "HURTO" },
    { id: "1d1fba7a-b88c-11e4-80cf-0025d318e182", nombre: "HURTO CALIFICADO" },
    { id: "1d29fa81-b88c-11e4-80cf-0025d318e182", nombre: "INCENDIO" },
    { id: "21a9843c-b88c-11e4-80cf-0025d318e182", nombre: "INCENDIO  SEGUIDO DE MUERTE" },
    { id: "1d35c2c5-b88c-11e4-80cf-0025d318e182", nombre: "INCENDIO CULPOSO" },
    { id: "1d4168a7-b88c-11e4-80cf-0025d318e182", nombre: "INDUCCION A LA FUGA" },
    { id: "1d4d77a1-b88c-11e4-80cf-0025d318e182", nombre: "INF.  LEY  6542 - VIOL.  FAMILIAR" },
    { id: "21d1461f-b88c-11e4-80cf-0025d318e182", nombre: "INF. ART. 193 BIS" },
    { id: "20beac82-b88c-11e4-80cf-0025d318e182", nombre: "INF. ART. 194" },
    { id: "213e7cdb-b88c-11e4-80cf-0025d318e182", nombre: "INF.ART. 246 (USURPACION DE AUTO)" },
    { id: "205870e8-b88c-11e4-80cf-0025d318e182", nombre: "INFRACCION LEY(11.179) MEDICAMENTOS" },
    { id: "1d5d7af3-b88c-11e4-80cf-0025d318e182", nombre: "INSTIGACION A COMETER DELITOS" },
    { id: "1d6a2c2e-b88c-11e4-80cf-0025d318e182", nombre: "INTIMIDACION PUBLICA" },
    { id: "1d7633d1-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES" },
    { id: "2213f821-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES  ART. 94 (MALA PRAXIS)" },
    { id: "2064754f-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES 89 (VIOLENCIA FLIAR)" },
    { id: "1d820cae-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES ART. 89" },
    { id: "1d8e0de8-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES ART. 90" },
    { id: "1d9a544c-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES ART. 91" },
    { id: "1da80826-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES ART. 94" },
    { id: "2169aeb1-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES ART.92" },
    { id: "1db512c4-b88c-11e4-80cf-0025d318e182", nombre: "LESIONES EN RIÑA" },
    { id: "1dc0ec9d-b88c-11e4-80cf-0025d318e182", nombre: "LEY 11.723 (PROP. INTELECTUAL)" },
    { id: "1dcc9b70-b88c-11e4-80cf-0025d318e182", nombre: "LEY 13944 INASISTENCIAFAMILIAR" },
    { id: "1dd8b2d6-b88c-11e4-80cf-0025d318e182", nombre: "LEY 14346 MALTRATO ANIMALES" },
    { id: "1de4a391-b88c-11e4-80cf-0025d318e182", nombre: "LEY 17671 IDENTIFICACION Y REG" },
    { id: "1dfa0a6f-b88c-11e4-80cf-0025d318e182", nombre: "LEY 22.362-MARCAS-" },
    { id: "1e080d6e-b88c-11e4-80cf-0025d318e182", nombre: "LEY 23737 ESTUPEFACIENTES" },
    { id: "1e149dc1-b88c-11e4-80cf-0025d318e182", nombre: "LEY 24 192 DEL DEPORTE" },
    { id: "1e251cee-b88c-11e4-80cf-0025d318e182", nombre: "LEY 24.481-PATENTES-" },
    { id: "1e330a77-b88c-11e4-80cf-0025d318e182", nombre: "LEY 6542 VIOL CONT LA MUJER" },
    { id: "20f4013a-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7196" },
    { id: "20d96f11-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819" },
    { id: "21deeaea-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819 -ART .100 -NEGACION D" },
    { id: "21ec20a4-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819 -ART .124 -PROSTITUCION" },
    { id: "208bbcdb-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819- ART. 113- DIST. VIA" },
    { id: "207f64da-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819- ART. 117- OFEN. MORA" },
    { id: "20a4c9c6-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819- ART. 118- ESCANDALO" },
    { id: "20b1bbe6-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819- ART. 119- EXIB COND" },
    { id: "20cc08c6-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819- ART. 123" },
    { id: "2098eebe-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7819- ART. 195- MERODEO" },
    { id: "1e400270-b88c-11e4-80cf-0025d318e182", nombre: "LEY 7943 - VIOLENCIA FAMILIAR" },
    { id: "1e4d774a-b88c-11e4-80cf-0025d318e182", nombre: "LEY DE ARMAS Y EXPLOSIVOS" },
    { id: "1e59a4b6-b88c-11e4-80cf-0025d318e182", nombre: "LEY DEL DEPORTE Nra 23184" },
    { id: "1e6863fb-b88c-11e4-80cf-0025d318e182", nombre: "LEY ELECTORAL Nra 5636" },
    { id: "1e76861e-b88c-11e4-80cf-0025d318e182", nombre: "LEY N 24270 NO CONTAC MENOR" },
    { id: "1e884aa7-b88c-11e4-80cf-0025d318e182", nombre: "LEY Nra 24410(INTENTO DE SECUESTRO)" },
    { id: "20491f1f-b88c-11e4-80cf-0025d318e182", nombre: "MUERTE DUDOSA" },
    { id: "21b6120f-b88c-11e4-80cf-0025d318e182", nombre: "ORDENES DEL DIA" },
    { id: "91fc0a2f-ae44-11e4-9ab6-0025d318e182", nombre: "OTRA CAUSA" },
    { id: "1e96a8de-b88c-11e4-80cf-0025d318e182", nombre: "PECULADO" },
    { id: "20e57385-b88c-11e4-80cf-0025d318e182", nombre: "PEDIDO DE CAPTURA" },
    { id: "215ce04c-b88c-11e4-80cf-0025d318e182", nombre: "PEDIDO DE SECUESTRO DE MOVILIDAD" },
    { id: "1ea2a804-b88c-11e4-80cf-0025d318e182", nombre: "PRIV.ILEG.LIBERTAD" },
    { id: "1eb0b770-b88c-11e4-80cf-0025d318e182", nombre: "QUEBRANTAR INHABILITACION" },
    { id: "1ebf79c1-b88c-11e4-80cf-0025d318e182", nombre: "RAPTO" },
    { id: "1ecd0b20-b88c-11e4-80cf-0025d318e182", nombre: "REMISION DE SUMARIO" },
    { id: "1edac26f-b88c-11e4-80cf-0025d318e182", nombre: "RESIST. O DESOB. A FUNC PUBLICO" },
    { id: "1ee8c5e1-b88c-11e4-80cf-0025d318e182", nombre: "RETENCION INDEBIDA" },
    { id: "1ef5d734-b88c-11e4-80cf-0025d318e182", nombre: "REVEL. ACTUAC. SECRETAS" },
    { id: "1f03406a-b88c-11e4-80cf-0025d318e182", nombre: "REVEL.SECRETO PROF." },
    { id: "1f0f3cc0-b88c-11e4-80cf-0025d318e182", nombre: "ROBO" },
    { id: "1f1e8f99-b88c-11e4-80cf-0025d318e182", nombre: "ROBO AGRAVADO" },
    { id: "1f2c5d85-b88c-11e4-80cf-0025d318e182", nombre: "ROBO SEGUIDO DE MUERTE" },
    { id: "1f380c3d-b88c-11e4-80cf-0025d318e182", nombre: "SECUESTRO EXTORSIVO" },
    { id: "1f442f65-b88c-11e4-80cf-0025d318e182", nombre: "SUICIDIO" },
    { id: "1f5226d7-b88c-11e4-80cf-0025d318e182", nombre: "SUPR.Y SUPOS ESTADO CIVIL" },
    { id: "1f5fa00b-b88c-11e4-80cf-0025d318e182", nombre: "SUPRESION DE LA IDENTIDAD" },
    { id: "218b8f56-b88c-11e4-80cf-0025d318e182", nombre: "SUPRESION DEL ESTADO CIVIL DE" },
    { id: "1f6cfa3e-b88c-11e4-80cf-0025d318e182", nombre: "SUSTRACCION  MENORES" },
    { id: "1f7e3643-b88c-11e4-80cf-0025d318e182", nombre: "TEN.ARMAS/EXP." },
    { id: "1f8b431f-b88c-11e4-80cf-0025d318e182", nombre: "TENT. EVASIÓN" },
    { id: "1f97065d-b88c-11e4-80cf-0025d318e182", nombre: "TENT. HOMICIDIO" },
    { id: "1fa4ab61-b88c-11e4-80cf-0025d318e182", nombre: "TENT. HURTO" },
    { id: "21f97311-b88c-11e4-80cf-0025d318e182", nombre: "TENT. ILEGITIMA DE LIBERTAD" },
    { id: "1fb1987f-b88c-11e4-80cf-0025d318e182", nombre: "TENT. ROBO" },
    { id: "1fc1490a-b88c-11e4-80cf-0025d318e182", nombre: "TENT. SUICIDIO" },
    { id: "217621c8-b88c-11e4-80cf-0025d318e182", nombre: "TENT. SUSTRACCION MENORES" },
    { id: "1fcd12be-b88c-11e4-80cf-0025d318e182", nombre: "TENT. VIOLACION" },
    { id: "22059164-b88c-11e4-80cf-0025d318e182", nombre: "TENT.EXTORCION" },
    { id: "1fd8b262-b88c-11e4-80cf-0025d318e182", nombre: "USURA" },
    { id: "1fe4d03f-b88c-11e4-80cf-0025d318e182", nombre: "USURPACION" },
    { id: "1ff18e63-b88c-11e4-80cf-0025d318e182", nombre: "USURPACION DE AGUA" },
    { id: "1ffe70ab-b88c-11e4-80cf-0025d318e182", nombre: "VIOLACION" },
    { id: "200bc89b-b88c-11e4-80cf-0025d318e182", nombre: "VIOLACION DE DOMICILIO" },
    { id: "201795df-b88c-11e4-80cf-0025d318e182", nombre: "VIOLACION DE SECRETO" },
  ],

  barrios: [
    { id: "6fcfe3b7-c3ce-4d51-8e9e-5fc43b58f4bb", nombre: "Barrio de Prueba" },
    { id: "5697c642-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Aramburu" },
    { id: "29e1a98a-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Bancario" },
    { id: "53da7f73-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra Canadá" },
    { id: "f9ebf59e-bc69-11e4-80a2-fa163e1d9e34", nombre: "Bra Capitán Lazo" },
    { id: "62aba4fd-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra Clemente Sarmiento" },
    { id: "ffa22f08-bc69-11e4-80a2-fa163e1d9e34", nombre: "Bra Costa Canal" },
    { id: "3a230021-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Del Bono" },
    { id: "65063cbd-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Edilco" },
    { id: "3d1d1196-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra El Portal Cooperarq I" },
    { id: "f3400e03-bc69-11e4-80a2-fa163e1d9e34", nombre: "Bra Gendarmería" },
    { id: "953ce556-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra Gral. Paz" },
    { id: "721ab870-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra La Fraternidad" },
    { id: "7736e650-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra Las Heras" },
    { id: "7e5bd88f-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Las Moreras" },
    { id: "8365f992-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Los Tamarindos" },
    { id: "816418ee-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra Luz y Fuerza" },
    { id: "4c238909-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Manantial" },
    { id: "8df75cc7-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Natania I" },
    { id: "a7880bca-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra Parque de Mayo" },
    { id: "96692129-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Patricias Sanjuaninas" },
    { id: "9ff19612-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra Residencial (Capital)" },
    { id: "c4c8f15c-bc6a-11e4-80a2-fa163e1d9e34", nombre: "Bra San Martín" },
    { id: "2768c656-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra Smata" },
    { id: "4d86924e-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Bra Urquiza" },
    { id: "e6a38266-bbbd-11e4-80a2-fa163e1d9e34", nombre: "B\u252c\u2591 Rivadavia Norte" },
    { id: "d494936b-bc69-11e4-80a2-fa163e1d9e34", nombre: "Villa América" },
    { id: "dbe3af28-bc69-11e4-80a2-fa163e1d9e34", nombre: "Villa del Carril" },
    { id: "9c47b0ce-bc6b-11e4-80a2-fa163e1d9e34", nombre: "Villa Margarita" },
    { id: "e15a8178-bc69-11e4-80a2-fa163e1d9e34", nombre: "Villa Palermo" },
    { id: "ebc3e7cf-bc69-11e4-80a2-fa163e1d9e34", nombre: "Villa Paula" },
  ],

  tiposdelugar: [
    { id: "36a169a4-a291-11e5-8dff-0090f58f4f32", nombre: "AGENCIA DE QUINIELA" },
    { id: "36a79368-a291-11e5-8dff-0090f58f4f32", nombre: "BALDIO" },
    { id: "a13473b2-b88f-11e4-80cf-0025d318e182", nombre: "BANCO" },
    { id: "36a7970a-a291-11e5-8dff-0090f58f4f32", nombre: "BAR" },
    { id: "36a7982d-a291-11e5-8dff-0090f58f4f32", nombre: "BASURERO MUNICIPAL" },
    { id: "36a7993e-a291-11e5-8dff-0090f58f4f32", nombre: "BIBLIOTECA" },
    { id: "36a79a5b-a291-11e5-8dff-0090f58f4f32", nombre: "BODEGA" },
    { id: "36a79b44-a291-11e5-8dff-0090f58f4f32", nombre: "BOLICHE" },
    { id: "36a79c36-a291-11e5-8dff-0090f58f4f32", nombre: "CAMPING" },
    { id: "36a79d21-a291-11e5-8dff-0090f58f4f32", nombre: "CAMPING MUNICIPAL" },
    { id: "36a79e19-a291-11e5-8dff-0090f58f4f32", nombre: "CANAL" },
    { id: "36a79eff-a291-11e5-8dff-0090f58f4f32", nombre: "CANCHA" },
    { id: "36a79fed-a291-11e5-8dff-0090f58f4f32", nombre: "CANTERA" },
    { id: "36a7a0d5-a291-11e5-8dff-0090f58f4f32", nombre: "CARCEL" },
    { id: "36a7a22b-a291-11e5-8dff-0090f58f4f32", nombre: "CARRO DE COMIDAS" },
    { id: "36a7a32c-a291-11e5-8dff-0090f58f4f32", nombre: "CASA DE COMERCIO" },
    { id: "36a7a414-a291-11e5-8dff-0090f58f4f32", nombre: "CASA RODANTE" },
    { id: "36a7a4ff-a291-11e5-8dff-0090f58f4f32", nombre: "CASINO" },
    { id: "36a7a603-a291-11e5-8dff-0090f58f4f32", nombre: "CEMENTERIO" },
    { id: "36a7a6f3-a291-11e5-8dff-0090f58f4f32", nombre: "CENTRO ASISTENCIAL" },
    { id: "36a7a9a8-a291-11e5-8dff-0090f58f4f32", nombre: "CENTRO COMERCIAL" },
    { id: "36a7aaa6-a291-11e5-8dff-0090f58f4f32", nombre: "CENTRO DE JUBILADOS" },
    { id: "36a7abe8-a291-11e5-8dff-0090f58f4f32", nombre: "CIC (CENTRO INTEGRADOR" },
    { id: "36a7add1-a291-11e5-8dff-0090f58f4f32", nombre: "CLUB" },
    { id: "36a7ace3-a291-11e5-8dff-0090f58f4f32", nombre: "CLÍANICA MÉDICA" },
    { id: "36a7aeb0-a291-11e5-8dff-0090f58f4f32", nombre: "COCHERAS" },
    { id: "36a7afa5-a291-11e5-8dff-0090f58f4f32", nombre: "COMISARÍA" },
    { id: "36a7b08f-a291-11e5-8dff-0090f58f4f32", nombre: "COMPLEJO CABAÑAS" },
    { id: "36a7b179-a291-11e5-8dff-0090f58f4f32", nombre: "CONSENCIONARIA" },
    { id: "36a7b262-a291-11e5-8dff-0090f58f4f32", nombre: "CONSULTORIOS" },
    { id: "36a7b35f-a291-11e5-8dff-0090f58f4f32", nombre: "CORRALON" },
    { id: "36a7b442-a291-11e5-8dff-0090f58f4f32", nombre: "CORREO" },
    { id: "36a7b527-a291-11e5-8dff-0090f58f4f32", nombre: "DEPOSITO" },
    { id: "36a7b610-a291-11e5-8dff-0090f58f4f32", nombre: "DESARMADERO" },
    { id: "36a7b703-a291-11e5-8dff-0090f58f4f32", nombre: "DIFERIMIENTO" },
    { id: "36a7b7f4-a291-11e5-8dff-0090f58f4f32", nombre: "DIQUE Y RIO" },
    { id: "36a7b8dd-a291-11e5-8dff-0090f58f4f32", nombre: "EDIFICIOS" },
    { id: "36a7b9ca-a291-11e5-8dff-0090f58f4f32", nombre: "EMPRESA" },
    { id: "36a7babd-a291-11e5-8dff-0090f58f4f32", nombre: "ESCRIBANIA" },
    { id: "a128ac9d-b88f-11e4-80cf-0025d318e182", nombre: "ESCUELA" },
    { id: "36a7bba5-a291-11e5-8dff-0090f58f4f32", nombre: "ESTAC DE SERVICIO" },
    { id: "36a7bc92-a291-11e5-8dff-0090f58f4f32", nombre: "ESTACIONAMIENTO" },
    { id: "36a7bfbd-a291-11e5-8dff-0090f58f4f32", nombre: "ESTADIO" },
    { id: "36a7c0d5-a291-11e5-8dff-0090f58f4f32", nombre: "EX-CAVIC" },
    { id: "36a7c1bd-a291-11e5-8dff-0090f58f4f32", nombre: "EXTERIOR NEGOCIO" },
    { id: "a10871fb-b88f-11e4-80cf-0025d318e182", nombre: "EXTERIOR VIVIENDA" },
    { id: "36a7c398-a291-11e5-8dff-0090f58f4f32", nombre: "FACULTAD" },
    { id: "36a7c48b-a291-11e5-8dff-0090f58f4f32", nombre: "FARMACIA" },
    { id: "36a7c570-a291-11e5-8dff-0090f58f4f32", nombre: "FERRETERÍA" },
    { id: "36a7c65c-a291-11e5-8dff-0090f58f4f32", nombre: "FINANCIERA" },
    { id: "36a7c741-a291-11e5-8dff-0090f58f4f32", nombre: "FINCA" },
    { id: "36a7c2af-a291-11e5-8dff-0090f58f4f32", nombre: "FÁBRICA" },
    { id: "36a7c83b-a291-11e5-8dff-0090f58f4f32", nombre: "GALERIA" },
    { id: "36a7c920-a291-11e5-8dff-0090f58f4f32", nombre: "GALPÓN" },
    { id: "36a7ca1e-a291-11e5-8dff-0090f58f4f32", nombre: "GIMNASIO" },
    { id: "36a7cb0a-a291-11e5-8dff-0090f58f4f32", nombre: "GOMERÍA" },
    { id: "36a7cbfd-a291-11e5-8dff-0090f58f4f32", nombre: "HELADERIA" },
    { id: "36a7ccef-a291-11e5-8dff-0090f58f4f32", nombre: "HOGAR DE ANCIANO" },
    { id: "36a7cde7-a291-11e5-8dff-0090f58f4f32", nombre: "HOGAR DE MENORES" },
    { id: "36a7ced4-a291-11e5-8dff-0090f58f4f32", nombre: "HOSPITAL DPTO" },
    { id: "36a7cfc8-a291-11e5-8dff-0090f58f4f32", nombre: "HOSPITAL M. QUIROGA" },
    { id: "36a7d0bd-a291-11e5-8dff-0090f58f4f32", nombre: "HOSPITAL MENTAL" },
    { id: "36a7d1a9-a291-11e5-8dff-0090f58f4f32", nombre: "HOSPITAL RAWSON" },
    { id: "1507becd-2faf-11e5-a87d-c46e1f155593", nombre: "HOTEL" },
    { id: "36a7d2ce-a291-11e5-8dff-0090f58f4f32", nombre: "IGLESIA" },
    { id: "36a7d3d0-a291-11e5-8dff-0090f58f4f32", nombre: "INMOBILIARIA" },
    { id: "36a7d771-a291-11e5-8dff-0090f58f4f32", nombre: "INSTITUCION PRIVADA" },
    { id: "36a7d87b-a291-11e5-8dff-0090f58f4f32", nombre: "INT CAJERO AUTOMATICO" },
    { id: "36a7d96a-a291-11e5-8dff-0090f58f4f32", nombre: "INT CHACARITA" },
    { id: "36a7da61-a291-11e5-8dff-0090f58f4f32", nombre: "INT CYBER" },
    { id: "36a7db4e-a291-11e5-8dff-0090f58f4f32", nombre: "INT DE EMPRESA" },
    { id: "36a7dc36-a291-11e5-8dff-0090f58f4f32", nombre: "INT DE MAQUINA VIAL" },
    { id: "36a7dd28-a291-11e5-8dff-0090f58f4f32", nombre: "INT JARDÍAN MATERNAL" },
    { id: "36a7de23-a291-11e5-8dff-0090f58f4f32", nombre: "INT PELUQUERÍA" },
    { id: "36a7df0e-a291-11e5-8dff-0090f58f4f32", nombre: "INT RADIO" },
    { id: "36a7dff2-a291-11e5-8dff-0090f58f4f32", nombre: "INT REMIS" },
    { id: "36a7e0da-a291-11e5-8dff-0090f58f4f32", nombre: "INT TAPICERIA" },
    { id: "36a7e1d5-a291-11e5-8dff-0090f58f4f32", nombre: "INT.SALON" },
    { id: "36a7e2bc-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR AMBULANCIA" },
    { id: "36a7e3a7-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR AUDITORIO" },
    { id: "a11cda37-b88f-11e4-80cf-0025d318e182", nombre: "INTERIOR AUTOMÓVIL" },
    { id: "36a7e590-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR CAMIONETA" },
    { id: "36a7e496-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR CAMIÓN" },
    { id: "36a7e71c-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR CEMENTERIO" },
    { id: "36a7e83c-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR CINE" },
    { id: "36a802a1-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR COLECTIVO" },
    { id: "36a80481-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR FÁBRICA" },
    { id: "36a80580-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR KIOSCO" },
    { id: "36a80676-a291-11e5-8dff-0090f58f4f32", nombre: "INTERIOR LAVADERO" },
    { id: "a0fe14bc-b88f-11e4-80cf-0025d318e182", nombre: "INTERIOR NEGOCIO" },
    { id: "a0ee625f-b88f-11e4-80cf-0025d318e182", nombre: "INTERIOR VIVIENDA" },
    { id: "36a80766-a291-11e5-8dff-0090f58f4f32", nombre: "LABORATORIO" },
    { id: "36a80863-a291-11e5-8dff-0090f58f4f32", nombre: "LOCUTORIO" },
    { id: "36a80cfa-a291-11e5-8dff-0090f58f4f32", nombre: "MAQUINAS VIALES" },
    { id: "36a80e01-a291-11e5-8dff-0090f58f4f32", nombre: "MATADERO" },
    { id: "36a80f5a-a291-11e5-8dff-0090f58f4f32", nombre: "MERCADO DEL ABASTO" },
    { id: "36a81054-a291-11e5-8dff-0090f58f4f32", nombre: "MINA" },
    { id: "36a8113d-a291-11e5-8dff-0090f58f4f32", nombre: "MOVIL POLICIAL" },
    { id: "36a81225-a291-11e5-8dff-0090f58f4f32", nombre: "MUNICIPALIDAD" },
    { id: "36a8130b-a291-11e5-8dff-0090f58f4f32", nombre: "MUSEO" },
    { id: "36a813f5-a291-11e5-8dff-0090f58f4f32", nombre: "NEGOCIO" },
    { id: "36a814e3-a291-11e5-8dff-0090f58f4f32", nombre: "OBRA EN CONSTRUCCIÓN" },
    { id: "36a815d2-a291-11e5-8dff-0090f58f4f32", nombre: "OBRADOR CENTRAL" },
    { id: "a14c4783-b88f-11e4-80cf-0025d318e182", nombre: "OFICINA" },
    { id: "8baf67de-a410-11e4-8b30-0025d318e182", nombre: "OTRO" },
    { id: "36a81714-a291-11e5-8dff-0090f58f4f32", nombre: "PARED" },
    { id: "36a81816-a291-11e5-8dff-0090f58f4f32", nombre: "PARQUE DE LA CIUDAD" },
    { id: "36a81915-a291-11e5-8dff-0090f58f4f32", nombre: "PARQUE DE RAWSON" },
    { id: "36a81a02-a291-11e5-8dff-0090f58f4f32", nombre: "PLANTA VERIFICADORA" },
    { id: "1507beaa-2faf-11e5-a87d-c46e1f155593", nombre: "PLAZA" },
    { id: "36a81af7-a291-11e5-8dff-0090f58f4f32", nombre: "PREDIO FERIAL" },
    { id: "36a81bfa-a291-11e5-8dff-0090f58f4f32", nombre: "RESIDENCIAL" },
    { id: "36a81cf9-a291-11e5-8dff-0090f58f4f32", nombre: "RESTAURANT" },
    { id: "36a81de4-a291-11e5-8dff-0090f58f4f32", nombre: "SALIDERA BANCARIA" },
    { id: "36a81ed2-a291-11e5-8dff-0090f58f4f32", nombre: "SANATORIO" },
    { id: "36a81fca-a291-11e5-8dff-0090f58f4f32", nombre: "SERVICIO PENITENCIARIO" },
    { id: "36a820be-a291-11e5-8dff-0090f58f4f32", nombre: "TALLER" },
    { id: "36a821a2-a291-11e5-8dff-0090f58f4f32", nombre: "TERMINAL" },
    { id: "36a82294-a291-11e5-8dff-0090f58f4f32", nombre: "TERRENO" },
    { id: "36a82392-a291-11e5-8dff-0090f58f4f32", nombre: "TRACTOR" },
    { id: "36a82482-a291-11e5-8dff-0090f58f4f32", nombre: "TREN" },
    { id: "36a82a93-a291-11e5-8dff-0090f58f4f32", nombre: "UNIVERSIDAD" },
    { id: "36a8297f-a291-11e5-8dff-0090f58f4f32", nombre: "UNIÓN VECINAL" },
    { id: "36a82b8d-a291-11e5-8dff-0090f58f4f32", nombre: "VIDEO CLUB" },
    { id: "36a82c74-a291-11e5-8dff-0090f58f4f32", nombre: "VIVERO" },
    { id: "a13ec560-b88f-11e4-80cf-0025d318e182", nombre: "VÍA PÚBLICA" },
  ],

  condicion: [
    // { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
    { id: "Denunciante", nombre: "Denunciante" },
    { id: "Damnificado", nombre: "Damnificado" },
  ],

  condicionPreliminarProcedencia: [
    // { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
    { id: "Denunciante", nombre: "Denunciante" },
    { id: "A Determinar", nombre: "A Determinar" },
    { id: "Damnificado", nombre: "Damnificado" },
  ],

  condicionCombinada: [
    { id: "Denunciante", nombre: "Denunciante" },
    { id: "Damnificado", nombre: "Damnificado" },
  ],

  condicionUFIDenunciante: [
    { id: "victima", nombre: "Víctima" },
    { id: "Damnificado", nombre: "Damnificado" },
  ],

  condicionUFIAcusado: [
    { id: "Detenido", nombre: "Detenido" },
    { id: "Acusado", nombre: "Acusado" },
  ],

  condicionUFIDenuncianteFallecido: [
    { id: "Fallecido", nombre: "Fallecido" },
    { id: "Damnificado", nombre: "Damnificado" },
  ],

  condicionUFIDenuncianteParadero: [{ id: "Denunciante", nombre: "Denunciante" }],

  condicionUFIAcusadoParadero: [{ id: "Extraviado", nombre: "Extraviado" }],

  condicionSumarioAcusado: [
    { id: "Acusado", nombre: "Acusado" },
    { id: "Detenido", nombre: "Detenido" },
  ],

  condicionContravencionAcusado: [
    // { id: "Denunciante y Damnificado", nombre: "Denunciante y Damnificado" },
    { id: "Detenido", nombre: "Detenido" },
    { id: "Acusado", nombre: "Acusado" },
  ],

  condicionPreliminar: [
    { id: "Protagonista", nombre: "Protagonista" },
    { id: "Acompañante", nombre: "Acompañante" },
    { id: "Damnificado", nombre: "Damnificado" },
  ],

  condicionCaidaCasual: [
    { id: "Protagonista", nombre: "Protagonista" },
    { id: "Acompañante", nombre: "Acompañante" },
    { id: "Peatón", nombre: "Peatón" },
  ],

  condicionTentativaSuicidio: [{ id: "Autolesionado", nombre: "Autolesionado" }],

  condicionAcusadoDetenido: [
    { id: "Detenido", nombre: "Detenido" },
    { id: "Acusado", nombre: "Acusado" },
  ],

  objetosAllTypes: [
    { id: "Denunciado", nombre: "Denunciado" },
    { id: "Recuperado", nombre: "Recuperado" },
    { id: "Secuestrado", nombre: "Secuestrado" },
  ],

  objetosOnlySecuestrado: [{ id: "Secuestrado", nombre: "Secuestrado" }],

  jerarquia: [
    { id: "1", nombre: "Agente" },
    { id: "2", nombre: "Cabo" },
    { id: "3", nombre: "Cabo Primero" },
    { id: "4", nombre: "Sargento" },
    { id: "5", nombre: "Sargento Primero" },
    { id: "6", nombre: "Sargento Ayudante" },
    { id: "7", nombre: "Sub Oficial Mayor" },
    { id: "8", nombre: "Sub Oficial Principal" },
    { id: "9", nombre: "Oficial Ayudante" },
    { id: "10", nombre: "Oficial Sub Inspector" },
    { id: "11", nombre: "Oficial Inspector" },
    { id: "12", nombre: "Oficial Principal" },
    { id: "12", nombre: "Sub Comisario" },
    { id: "12", nombre: "Comisario" },
    { id: "12", nombre: "Comisario Inspector" },
    { id: "12", nombre: "Comisario Mayor" },
    { id: "12", nombre: "Comisario General" },
  ],

  tipoDocumento: [
    { id: "DNI", nombre: "DNI" },
    { id: "PAS", nombre: "Pasaporte" },
    { id: "SI", nombre: "Sin Identificación" },
    { id: "CE", nombre: "Cédula de Extranjería" },
    { id: "CC", nombre: "Cédula de Ciudadanía" },
    { id: "TI", nombre: "Tarjeta de Identidad" },
    { id: "OT", nombre: "Otro" },
  ],

  sexo: [
    { id: "F", nombre: "Femenino" },
    { id: "M", nombre: "Masculino" },
  ],
  exhibeDocumento: [
    { id: 1, nombre: "Si" },
    { id: 0, nombre: "No" },
  ],
  tieneEstudios: [
    { id: 1, nombre: "Si" },
    { id: 0, nombre: "No" },
  ],

  estadocivil: [
    { id: "2", nombre: "Casado/a" },
    { id: "4", nombre: "Divorciado/a" },
    { id: "3", nombre: "Separado/a" },
    { id: "1", nombre: "Soltero/a" },
    { id: "5", nombre: "Viudo/a" },
  ],

  enum_instruccion: [
    { id: "primaria", nombre: "Primaria" },
    { id: "secundaria", nombre: "Secundaria" },
    { id: "terciaria", nombre: "Terciaria" },
    { id: "universitaria", nombre: "Universitaria" },
    { id: "no_sabe_leer_no_sabe_firmar", nombre: "No sabe leer, no sabe firmar" },
    { id: "no_sabe_leer_sabe_firmar", nombre: "No sabe leer, si sabe firmar" },
    { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
  ],

  headGarmentList: [
    { id: "0", nombre: "Bincha", article: "una" },
    { id: "1", nombre: "Boina", article: "una" },
    { id: "2", nombre: "Casco ciclista", article: "un" },
    { id: "3", nombre: "Casco motociclista", article: "un" },
    { id: "4", nombre: "Gorra", article: "una" },
    { id: "5", nombre: "Gorro", article: "un" },
    { id: "6", nombre: "Pañuelo", article: "un" },
    { id: "7", nombre: "Pasamontaña", article: "un" },
    { id: "8", nombre: "Sombrero", article: "un" },
    { id: "9", nombre: "Visera", article: "una" },
  ],

  headStyleList: [
    { id: "0", nombre: "Formal" },
    { id: "1", nombre: "Informal" },
    { id: "2", nombre: "Laboral" },
  ],

  headColorList: [
    { id: "0", nombre: "Amarillo" },
    { id: "1", nombre: "Anaranjado" },
    { id: "2", nombre: "Azul" },
    { id: "3", nombre: "Beige" },
    { id: "4", nombre: "Blanco" },
    { id: "5", nombre: "Celeste" },
    { id: "6", nombre: "Fucsia" },
    { id: "7", nombre: "Gris" },
    { id: "8", nombre: "Lila" },
    { id: "9", nombre: "Marrón" },
    { id: "10", nombre: "Morado" },
    { id: "11", nombre: "Negro" },
    { id: "12", nombre: "Rojo" },
    { id: "13", nombre: "Rosado" },
    { id: "14", nombre: "Verde" },
    { id: "15", nombre: "Oscuro" },
    { id: "16", nombre: "Claro" },
    { id: "17", nombre: "Flúor" },
  ],

  sBodyGarmentList: [
    { id: "0", nombre: "Blusa", article: "una" },
    { id: "1", nombre: "Camisa", article: "una" },
    { id: "2", nombre: "Campera", article: "una" },
    { id: "3", nombre: "Pullover", article: "un" },
    { id: "4", nombre: "Remera", article: "una" },
    { id: "5", nombre: "Saco", article: "un" },
    { id: "6", nombre: "Sobretodo", article: "un" },
  ],

  sBodySleevesList: [
    { id: "0", nombre: "Mangas cortas" },
    { id: "1", nombre: "Mangas largas" },
    { id: "2", nombre: "Sin mangas" },
  ],

  sBodyStyleList: [
    { id: "0", nombre: "Formal" },
    { id: "1", nombre: "Informal" },
    { id: "2", nombre: "Laboral" },
  ],

  sBodyColorList: [
    { id: "0", nombre: "Amarillo" },
    { id: "1", nombre: "Anaranjado" },
    { id: "2", nombre: "Azul" },
    { id: "3", nombre: "Beige" },
    { id: "4", nombre: "Blanco" },
    { id: "5", nombre: "Celeste" },
    { id: "6", nombre: "Fucsia" },
    { id: "7", nombre: "Gris" },
    { id: "8", nombre: "Lila" },
    { id: "9", nombre: "Marrón" },
    { id: "10", nombre: "Morado" },
    { id: "11", nombre: "Negro" },
    { id: "12", nombre: "Rojo" },
    { id: "13", nombre: "Rosado" },
    { id: "14", nombre: "Verde" },
    { id: "15", nombre: "Oscuro" },
    { id: "16", nombre: "Claro" },
    { id: "17", nombre: "Flúor" },
  ],

  iBodyGarmentList: [
    { id: "0", nombre: "Bermuda", article: "una" },
    { id: "1", nombre: "Calza capri", article: "una" },
    { id: "2", nombre: "Calza corta", article: "una" },
    { id: "3", nombre: "Calza larga", article: "una" },
    { id: "4", nombre: "Falda corta", article: "una" },
    { id: "5", nombre: "Falda larga", article: "una" },
    { id: "6", nombre: "Jardinera corta", article: "una" },
    { id: "7", nombre: "Jardinera larga", article: "una" },
    { id: "8", nombre: "Mameluco", article: "un" },
    { id: "9", nombre: "Pantalón capri", article: "un" },
    { id: "10", nombre: "Pantalón largo", article: "un" },
    { id: "11", nombre: "Short", article: "un" },
  ],

  iBodyStyleList: [
    { id: "0", nombre: "Formal" },
    { id: "1", nombre: "Informal" },
    { id: "2", nombre: "Laboral" },
  ],

  iBodyColorList: [
    { id: "0", nombre: "Amarillo" },
    { id: "1", nombre: "Anaranjado" },
    { id: "2", nombre: "Azul" },
    { id: "3", nombre: "Beige" },
    { id: "4", nombre: "Blanco" },
    { id: "5", nombre: "Celeste" },
    { id: "6", nombre: "Fucsia" },
    { id: "7", nombre: "Gris" },
    { id: "8", nombre: "Lila" },
    { id: "9", nombre: "Marrón" },
    { id: "10", nombre: "Morado" },
    { id: "11", nombre: "Negro" },
    { id: "12", nombre: "Rojo" },
    { id: "13", nombre: "Rosado" },
    { id: "14", nombre: "Verde" },
    { id: "15", nombre: "Oscuro" },
    { id: "16", nombre: "Claro" },
    { id: "17", nombre: "Flúor" },
  ],

  feetFootwearList: [
    { id: "0", nombre: "Zapatillas", article: "unas" },
    { id: "1", nombre: "Botines", article: "unos" },
    { id: "2", nombre: "Botas", article: "unas" },
    { id: "3", nombre: "Sandalias", article: "unas" },
    { id: "4", nombre: "Chancletas", article: "unas" },
    { id: "5", nombre: "Alpargatas", article: "unas" },
    { id: "6", nombre: "Zapatos", article: "unos" },
    { id: "7", nombre: "Zapatos de tacón", article: "unos" },
    { id: "8", nombre: "Pantuflas", article: "unas" },
  ],

  feetStyleList: [
    { id: "0", nombre: "Formales" },
    { id: "1", nombre: "Informales" },
    { id: "2", nombre: "Laborales" },
  ],

  feetColorList: [
    { id: "0", nombre: "Amarillo" },
    { id: "1", nombre: "Anaranjado" },
    { id: "2", nombre: "Azul" },
    { id: "3", nombre: "Beige" },
    { id: "4", nombre: "Blanco" },
    { id: "5", nombre: "Celeste" },
    { id: "6", nombre: "Fucsia" },
    { id: "7", nombre: "Gris" },
    { id: "8", nombre: "Lila" },
    { id: "9", nombre: "Marrón" },
    { id: "10", nombre: "Morado" },
    { id: "11", nombre: "Negro" },
    { id: "12", nombre: "Rojo" },
    { id: "13", nombre: "Rosado" },
    { id: "14", nombre: "Verde" },
    { id: "15", nombre: "Oscuro" },
    { id: "16", nombre: "Claro" },
    { id: "17", nombre: "Flúor" },
  ],

  hairLengthList: [
    { id: "0", nombre: "Calvo" },
    { id: "1", nombre: "Rapado" },
    { id: "2", nombre: "Corto" },
    { id: "3", nombre: "Largo" },
    { id: "4", nombre: "Extra largo" },
  ],

  hairTypeList: [
    { id: "0", nombre: "Lacio" },
    { id: "1", nombre: "Ondulado" },
    { id: "2", nombre: "Rizado" },
    { id: "3", nombre: "Crespo" },
  ],

  hairColorList: [
    { id: "0", nombre: "Blanco" },
    { id: "1", nombre: "Canoso" },
    { id: "2", nombre: "Castaño" },
    { id: "3", nombre: "Negro" },
    { id: "4", nombre: "Pelirrojo" },
    { id: "5", nombre: "Rubio" },
    { id: "6", nombre: "Oscuro" },
    { id: "7", nombre: "Claro" },
  ],

  genderList: [
    { id: "0", nombre: "Femenino" },
    { id: "1", nombre: "Masculino" },
  ],

  heightList: [
    { id: "0", nombre: "Muy baja" },
    { id: "1", nombre: "Baja" },
    { id: "2", nombre: "Mediana" },
    { id: "3", nombre: "Alta" },
    { id: "4", nombre: "Muy alta" },
  ],

  volumeList: [
    { id: "0", male: "Muy delgado", femenine: "Muy delgada" },
    { id: "1", male: "Delgado", femenine: "Delgada" },
    { id: "2", male: "Promedio", femenine: "Promedio" },
    { id: "3", male: "Obeso", femenine: "Obesa" },
    { id: "4", male: "Muy obeso", femenine: "Muy obesa" },
  ],

  stageOfLifeList: [
    { id: "0", nombre: "Infante" },
    { id: "1", nombre: "Adolescente" },
    { id: "2", nombre: "Juvenil" },
    { id: "3", nombre: "Adulto" },
    { id: "4", nombre: "Adulto mayor" },
  ],

  headPartList: [
    { id: "0", nombre: "Cabeza", article: "la" },
    { id: "1", nombre: "Cuello", article: "el" },
    { id: "2", nombre: "Rostro", article: "el" },
  ],

  headZoneList: [
    { id: "0", nombre: "Inferior" },
    { id: "1", nombre: "Intermedia" },
    { id: "2", nombre: "Superior" },
    { id: "3", nombre: "Frontal" },
    { id: "4", nombre: "Posterior" },
    { id: "5", nombre: "Central" },
    { id: "6", nombre: "Externa" },
    { id: "7", nombre: "Interna" },
    { id: "8", nombre: "Derecha" },
    { id: "9", nombre: "Izquierda" },
  ],

  headTypeList: [
    { id: "0", nombre: "Escudo", article: "un" },
    { id: "1", nombre: "Imagen", article: "una" },
    { id: "2", nombre: "Texto", article: "un" },
    { id: "3", nombre: "Tribal", article: "un" },
  ],

  bodyPartList: [
    { id: "0", nombre: "Espalda", article: "la" },
    { id: "1", nombre: "Pecho", article: "el" },
  ],

  bodyZoneList: [
    { id: "0", nombre: "Inferior" },
    { id: "1", nombre: "Intermedia" },
    { id: "2", nombre: "Superior" },
    { id: "3", nombre: "Frontal" },
    { id: "4", nombre: "Posterior" },
    { id: "5", nombre: "Central" },
    { id: "6", nombre: "Externa" },
    { id: "7", nombre: "Interna" },
    { id: "8", nombre: "Derecha" },
    { id: "9", nombre: "Izquierda" },
  ],

  bodyTypeList: [
    { id: "0", nombre: "Escudo", article: "un" },
    { id: "1", nombre: "Imagen", article: "una" },
    { id: "2", nombre: "Texto", article: "un" },
    { id: "3", nombre: "Tribal", article: "un" },
  ],

  armPartList: [
    { id: "0", nombre: "Hombro", article: "el" },
    { id: "1", nombre: "Brazo", article: "el" },
    { id: "2", nombre: "Codo", article: "el" },
    { id: "3", nombre: "Antebrazo", article: "el" },
    { id: "4", nombre: "Mano", article: "la" },
  ],

  armSideList: [
    { id: "0", nombre: "Derecha", male: "Derecho" },
    { id: "1", nombre: "Izquierda", male: "Izquierdo" },
  ],

  armZoneList: [
    { id: "0", nombre: "Inferior" },
    { id: "1", nombre: "Intermedia" },
    { id: "2", nombre: "Superior" },
    { id: "3", nombre: "Frontal" },
    { id: "4", nombre: "Posterior" },
    { id: "5", nombre: "Central" },
    { id: "6", nombre: "Externa" },
    { id: "7", nombre: "Interna" },
  ],

  armTypeList: [
    { id: "0", nombre: "Escudo", article: "un" },
    { id: "1", nombre: "Imagen", article: "una" },
    { id: "2", nombre: "Texto", article: "un" },
    { id: "3", nombre: "Tribal", article: "un" },
  ],

  legPartList: [
    { id: "0", nombre: "Mulso", article: "el" },
    { id: "1", nombre: "Rodilla", article: "la" },
    { id: "2", nombre: "Pantorrilla", article: "la" },
    { id: "3", nombre: "Tobillo", article: "el" },
    { id: "4", nombre: "Pie", article: "el" },
  ],

  legSideList: [
    { id: "0", nombre: "Derecha", male: "Derecho" },
    { id: "1", nombre: "Izquierda", male: "Izquierdo" },
  ],

  legZoneList: [
    { id: "0", nombre: "Inferior" },
    { id: "1", nombre: "Intermedia" },
    { id: "2", nombre: "Superior" },
    { id: "3", nombre: "Frontal" },
    { id: "4", nombre: "Posterior" },
    { id: "5", nombre: "Central" },
    { id: "6", nombre: "Externa" },
    { id: "7", nombre: "Interna" },
  ],

  legTypeList: [
    { id: "0", nombre: "Escudo", article: "un" },
    { id: "1", nombre: "Imagen", article: "una" },
    { id: "2", nombre: "Texto", article: "un" },
    { id: "3", nombre: "Tribal", article: "un" },
  ],

  accessoryList: [
    { id: "0", nombre: "Anillo", article: "un" },
    { id: "1", nombre: "Aros", article: "unos" },
    { id: "2", nombre: "Cartera", article: "una" },
    { id: "3", nombre: "Cinto", article: "un" },
    { id: "4", nombre: "Collar", article: "un" },
    { id: "5", nombre: "Lentes de sol", article: "unos" },
    { id: "6", nombre: "Piercing", article: "un" },
    { id: "7", nombre: "Pulsera", article: "una" },
    { id: "8", nombre: "Reloj", article: "un" },
    { id: "9", nombre: "Riñonera", article: "una" },
  ],

  partList: [
    { id: "0", nombre: "Antebrazo", gender: "male" },
    { id: "1", nombre: "Brazo", gender: "male" },
    { id: "2", nombre: "Cabeza", gender: "femenine" },
    { id: "3", nombre: "Ceja", gender: "femenine" },
    { id: "4", nombre: "Codo", gender: "male" },
    { id: "5", nombre: "Cuello", gender: "male" },
    { id: "6", nombre: "Espalda", gender: "femenine" },
    { id: "7", nombre: "Hombro", gender: "male" },
    { id: "8", nombre: "Mano", gender: "femenine" },
    { id: "9", nombre: "Mulso", gender: "male" },
    { id: "10", nombre: "Nariz", gender: "femenine" },
    { id: "11", nombre: "Oreja", gender: "femenine" },
    { id: "12", nombre: "Pantorrilla", gender: "femenine" },
    { id: "13", nombre: "Pecho", gender: "male" },
    { id: "14", nombre: "Pie", gender: "male" },
    { id: "15", nombre: "Rodilla", gender: "femenine" },
    { id: "16", nombre: "Rostro", gender: "male" },
    { id: "17", nombre: "Tobillo", gender: "male" },
  ],

  zoneList: [
    { id: "0", nombre: "Inferior", male: "Inferior" },
    { id: "1", nombre: "Intermedia", male: "Intermedio" },
    { id: "2", nombre: "Superior", male: "Superior" },
    { id: "3", nombre: "Frontal", male: "Frontal" },
    { id: "4", nombre: "Posterior", male: "Posterior" },
    { id: "5", nombre: "Central", male: "Central" },
    { id: "6", nombre: "Externa", male: "Externo" },
    { id: "7", nombre: "Interna", male: "Interno" },
    { id: "8", nombre: "Derecha", male: "Derecho" },
    { id: "9", nombre: "Izquierda", male: "Izquierdo" },
  ],

  colorList: [
    { id: "0", nombre: "Amarillo" },
    { id: "1", nombre: "Anaranjado" },
    { id: "2", nombre: "Azul" },
    { id: "3", nombre: "Beige" },
    { id: "4", nombre: "Blanco" },
    { id: "5", nombre: "Celeste" },
    { id: "6", nombre: "Fucsia" },
    { id: "7", nombre: "Gris" },
    { id: "8", nombre: "Lila" },
    { id: "9", nombre: "Marrón" },
    { id: "10", nombre: "Morado" },
    { id: "11", nombre: "Negro" },
    { id: "12", nombre: "Rojo" },
    { id: "13", nombre: "Rosado" },
    { id: "14", nombre: "Verde" },
    { id: "15", nombre: "Oscuro" },
    { id: "16", nombre: "Claro" },
    { id: "17", nombre: "Flúor" },
  ],

  mobilityList: [
    { id: "0", nombre: "A pie", article: "" },
    { id: "1", nombre: "Bicicleta", article: "en una" },
    { id: "2", nombre: "Motocicleta", article: "en una" },
    { id: "3", nombre: "Automovil", article: "en un" },
  ],

  mobilityColorListEnabled: [
    { id: "0", nombre: "Amarillo" },
    { id: "1", nombre: "Anaranjado" },
    { id: "2", nombre: "Azul" },
    { id: "3", nombre: "Beige" },
    { id: "4", nombre: "Blanco" },
    { id: "5", nombre: "Celeste" },
    { id: "6", nombre: "Dorado" },
    { id: "7", nombre: "Fucsia" },
    { id: "8", nombre: "Gris" },
    { id: "9", nombre: "Lila" },
    { id: "10", nombre: "Marrón" },
    { id: "11", nombre: "Morado" },
    { id: "12", nombre: "Negro" },
    { id: "13", nombre: "Plateado" },
    { id: "14", nombre: "Rojo" },
    { id: "15", nombre: "Rosado" },
    { id: "16", nombre: "Verde" },
    { id: "17", nombre: "Oscuro" },
    { id: "18", nombre: "Claro" },
    { id: "19", nombre: "Flúor" },
    { id: "20", nombre: "Ploteado" },
  ],

  typeBikeList: [
    { id: "0", nombre: "Bicicross" },
    { id: "1", nombre: "Carrera" },
    { id: "2", nombre: "Playera" },
    { id: "3", nombre: "Rutera" },
    { id: "4", nombre: "Todoterreno" },
    { id: "5", nombre: "Urbana" },
  ],

  typeMotorcycleList: [
    { id: "0", nombre: "Chopper" },
    { id: "1", nombre: "Ciclomotor" },
    { id: "2", nombre: "Deportiva" },
    { id: "3", nombre: "Enduro" },
    { id: "4", nombre: "Megasooter" },
    { id: "5", nombre: "Motocross" },
    { id: "6", nombre: "Rutera" },
    { id: "7", nombre: "Scooter" },
    { id: "8", nombre: "Trail" },
    { id: "9", nombre: "Urbana" },
  ],

  typeCarList: [
    { id: "0", nombre: "Camión" },
    { id: "1", nombre: "Colectivo" },
    { id: "2", nombre: "Coupe" },
    { id: "3", nombre: "Descapotable" },
    { id: "4", nombre: "Furgón" },
    { id: "5", nombre: "Furgoneta" },
    { id: "6", nombre: "Pickup" },
    { id: "7", nombre: "Rural" },
    { id: "8", nombre: "Sedan" },
    { id: "9", nombre: "Van" },
  ],

  brandBikeList: [
    { id: "0", nombre: "BMC" },
    { id: "1", nombre: "Cube" },
    { id: "2", nombre: "Orbea" },
    { id: "3", nombre: "Scott" },
    { id: "4", nombre: "SLP" },
    { id: "5", nombre: "TopMega" },
    { id: "6", nombre: "Trek" },
    { id: "7", nombre: "Venzo" },
  ],

  brandMotorcycleList: [
    { id: "0", nombre: "Corven" },
    { id: "1", nombre: "Gilera" },
    { id: "2", nombre: "Guerrero" },
    { id: "3", nombre: "Honda" },
    { id: "4", nombre: "Kawasaki" },
    { id: "5", nombre: "Keller" },
    { id: "6", nombre: "Maverick" },
    { id: "7", nombre: "Mondial" },
    { id: "8", nombre: "Motomel" },
    { id: "9", nombre: "Siam" },
    { id: "10", nombre: "Suzuki" },
    { id: "11", nombre: "Yamaha" },
    { id: "12", nombre: "Zanella" },
  ],

  brandCarList: [
    { id: "0", nombre: "Chevrolet" },
    { id: "1", nombre: "Citroen" },
    { id: "2", nombre: "Dodge" },
    { id: "3", nombre: "Fiat" },
    { id: "4", nombre: "Ford" },
    { id: "5", nombre: "Iveco" },
    { id: "6", nombre: "Mercedes Benz" },
    { id: "7", nombre: "Nissan" },
    { id: "8", nombre: "Opel" },
    { id: "9", nombre: "Peugeot" },
    { id: "10", nombre: "Renault" },
    { id: "11", nombre: "Scania" },
    { id: "12", nombre: "Toyota" },
    { id: "13", nombre: "Volkswagen" },
  ],

  whiteWeaponList: [
    { id: "0", nombre: "Cuchillo", article: "Un" },
    { id: "1", nombre: "Daga", article: "Una" },
    { id: "2", nombre: "Espada", article: "Una" },
    { id: "3", nombre: "Hacha", article: "Una" },
    { id: "4", nombre: "Lanza", article: "Una" },
    { id: "5", nombre: "Machete", article: "Un" },
    { id: "6", nombre: "Navaja", article: "Una" },
    { id: "7", nombre: "Puñal", article: "Un" },
    { id: "8", nombre: "Sable", article: "Un" },
  ],

  fireWeaponList: [
    { id: "0", nombre: "Carabina", article: "Una" },
    { id: "1", nombre: "Escopeta", article: "Una" },
    { id: "2", nombre: "Pistola", article: "Una" },
    { id: "3", nombre: "Revólver", article: "Un" },
    { id: "4", nombre: "Rifle", article: "Un" },
    { id: "5", nombre: "Tumbera", article: "Una" },
  ],

  objectWeaponList: [
    { id: "0", nombre: "Alambre", article: "Un" },
    { id: "1", nombre: "Bate", article: "Un" },
    { id: "2", nombre: "Cadena", article: "Una" },
    { id: "3", nombre: "Hierro", article: "Un" },
    { id: "4", nombre: "Ladrillo", article: "Un" },
    { id: "5", nombre: "Manopla", article: "Una" },
    { id: "6", nombre: "Palo", article: "Un" },
    { id: "7", nombre: "Piedra", article: "Una" },
    { id: "8", nombre: "Tonfa", article: "Una" },
    { id: "9", nombre: "Tubo", article: "Un" },
  ],

  weaponColorList: [
    { id: "0", nombre: "Blanco" },
    { id: "1", nombre: "Claro" },
    { id: "2", nombre: "Dorado" },
    { id: "3", nombre: "Gris" },
    { id: "4", nombre: "Negro" },
    { id: "5", nombre: "Oscuro" },
    { id: "6", nombre: "Plateado" },
  ],

  typeOfWeaponList: [
    { id: "0", nombre: "Arma blanca" },
    { id: "1", nombre: "Arma de fuego" },
    { id: "2", nombre: "Objeto" },
  ],

  nacionalidad: [
    { id: "12", nombre: "AFGANISTÁN" },
    { id: "2", nombre: "ALBANIA" },
    { id: "3", nombre: "ALEMANIA" },
    { id: "5", nombre: "ANDORRA" },
    { id: "6", nombre: "ANGOLA" },
    { id: "7", nombre: "ANGUILA" },
    { id: "8", nombre: "ANTIGUA Y BARBUDA" },
    { id: "9", nombre: "ANTILLAS NEERLANDESAS" },
    { id: "10", nombre: "ANTÁRTIDA" },
    { id: "11", nombre: "ARABIA SAUDITA" },
    { id: "4", nombre: "ARGELIA" },
    { id: "1", nombre: "ARGENTINA" },
    { id: "13", nombre: "ARMENIA" },
    { id: "14", nombre: "ARUBA" },
    { id: "15", nombre: "AUSTRALIA" },
    { id: "16", nombre: "AUSTRIA" },
    { id: "17", nombre: "AZERBAIYÁN" },
    { id: "18", nombre: "BAHAMAS" },
    { id: "20", nombre: "BANGLADESH" },
    { id: "21", nombre: "BARBADOS" },
    { id: "22", nombre: "BELICE" },
    { id: "23", nombre: "BENIN" },
    { id: "24", nombre: "BERMUDAS" },
    { id: "25", nombre: "BIELORRUSIA" },
    { id: "26", nombre: "BOLIVIA" },
    { id: "27", nombre: "BOSNIA Y HERZEGOVINA" },
    { id: "28", nombre: "BOTSWANA" },
    { id: "29", nombre: "BRASIL" },
    { id: "31", nombre: "BULGARIA" },
    { id: "32", nombre: "BURKINA FASO" },
    { id: "33", nombre: "BURUNDI" },
    { id: "34", nombre: "BUTÁN" },
    { id: "35", nombre: "BÉLGICA" },
    { id: "36", nombre: "CABO VERDE" },
    { id: "37", nombre: "CAMBOYA" },
    { id: "38", nombre: "CAMERÚN" },
    { id: "39", nombre: "CANADÁ" },
    { id: "40", nombre: "CHAD" },
    { id: "41", nombre: "CHILE" },
    { id: "42", nombre: "CHINA" },
    { id: "43", nombre: "CHIPRE" },
    { id: "44", nombre: "CIUDAD DEL VATICANO" },
    { id: "45", nombre: "COLOMBIA" },
    { id: "46", nombre: "COMORAS" },
    { id: "47", nombre: "COREA DEL NORTE" },
    { id: "48", nombre: "COREA DEL SUR" },
    { id: "50", nombre: "COSTA DE MARFIL" },
    { id: "49", nombre: "COSTA RICA" },
    { id: "51", nombre: "CROACIA" },
    { id: "52", nombre: "CUBA" },
    { id: "53", nombre: "DINAMARCA" },
    { id: "54", nombre: "DOMINICA" },
    { id: "55", nombre: "ECUADOR" },
    { id: "56", nombre: "EGIPTO" },
    { id: "57", nombre: "EL SALVADOR" },
    { id: "58", nombre: "EMIRATOS ÁRABES UNIDOS" },
    { id: "59", nombre: "ERITREA" },
    { id: "60", nombre: "ESLOVAQUIA" },
    { id: "61", nombre: "ESLOVENIA" },
    { id: "62", nombre: "ESPAÑA" },
    { id: "63", nombre: "ESTADOS UNIDOS" },
    { id: "64", nombre: "ESTONIA" },
    { id: "65", nombre: "ETIOPÍA" },
    { id: "66", nombre: "FILIPINAS" },
    { id: "67", nombre: "FINLANDIA" },
    { id: "68", nombre: "FIYI" },
    { id: "69", nombre: "FRANCIA" },
    { id: "71", nombre: "GAMBIA" },
    { id: "72", nombre: "GEORGIA" },
    { id: "73", nombre: "GHANA" },
    { id: "74", nombre: "GIBRALTAR" },
    { id: "75", nombre: "GRANADA" },
    { id: "76", nombre: "GRECIA" },
    { id: "77", nombre: "GROENLANDIA" },
    { id: "78", nombre: "GUADALUPE" },
    { id: "79", nombre: "GUAM" },
    { id: "80", nombre: "GUATEMALA" },
    { id: "81", nombre: "GUAYANA FRANCESA" },
    { id: "82", nombre: "GUERNSEY" },
    { id: "83", nombre: "GUINEA" },
    { id: "84", nombre: "GUINEA ECUATORIAL" },
    { id: "85", nombre: "GUINEA-BISSAU" },
    { id: "86", nombre: "GUYANA" },
    { id: "87", nombre: "HAITÍA" },
    { id: "88", nombre: "HONDURAS" },
    { id: "89", nombre: "HONG KONG" },
    { id: "90", nombre: "HUNGRÍA" },
    { id: "91", nombre: "INDIA" },
    { id: "92", nombre: "INDONESIA" },
    { id: "93", nombre: "IRAQ" },
    { id: "94", nombre: "IRLANDA" },
    { id: "95", nombre: "IRÁN" },
    { id: "96", nombre: "ISLA BOUVET" },
    { id: "97", nombre: "ISLA DE MAN" },
    { id: "98", nombre: "ISLA DE NAVIDAD" },
    { id: "99", nombre: "ISLANDIA" },
    { id: "100", nombre: "ISLAS CAIMÁN" },
    { id: "101", nombre: "ISLAS COCOS" },
    { id: "102", nombre: "ISLAS COOK" },
    { id: "103", nombre: "ISLAS FEROE" },
    { id: "104", nombre: "ISLAS GEORGIAS DEL SUR Y SANDWICH DEL SUR" },
    { id: "105", nombre: "ISLAS HEARD Y MCDONALD" },
    { id: "106", nombre: "ISLAS MARIANAS DEL NORTE" },
    { id: "107", nombre: "ISLAS MARSHALL" },
    { id: "108", nombre: "ISLAS PITCAIRN" },
    { id: "109", nombre: "ISLAS SALOMÓN" },
    { id: "110", nombre: "ISLAS TURCAS Y CAICOS" },
    { id: "113", nombre: "ISLAS ULTRAMARINAS DE ESTADOS UNIDOS" },
    { id: "111", nombre: "ISLAS VÍARGENES BRITÁNICAS" },
    { id: "112", nombre: "ISLAS VÍARGENES ESTADOUNIDENSES" },
    { id: "114", nombre: "ISRAEL" },
    { id: "115", nombre: "ITALIA" },
    { id: "116", nombre: "JAMAICA" },
    { id: "117", nombre: "JAPÓN" },
    { id: "118", nombre: "JERSEY" },
    { id: "119", nombre: "JORDANIA" },
    { id: "120", nombre: "KAZAJISTÁN" },
    { id: "121", nombre: "KENIA" },
    { id: "122", nombre: "KIRGUISTÁN" },
    { id: "123", nombre: "KIRIBATI" },
    { id: "124", nombre: "KUWAIT" },
    { id: "125", nombre: "LAOS" },
    { id: "126", nombre: "LESOTO" },
    { id: "127", nombre: "LETONIA" },
    { id: "128", nombre: "LIBERIA" },
    { id: "129", nombre: "LIBIA" },
    { id: "130", nombre: "LIECHTENSTEIN" },
    { id: "131", nombre: "LITUANIA" },
    { id: "132", nombre: "LUXEMBURGO" },
    { id: "133", nombre: "LÍABANO" },
    { id: "134", nombre: "MACAO" },
    { id: "135", nombre: "MADAGASCAR" },
    { id: "136", nombre: "MALASIA" },
    { id: "137", nombre: "MALAUI" },
    { id: "138", nombre: "MALDIVAS" },
    { id: "139", nombre: "MALTA" },
    { id: "141", nombre: "MARRUECOS" },
    { id: "142", nombre: "MARTINICA" },
    { id: "143", nombre: "MAURICIO" },
    { id: "144", nombre: "MAURITANIA" },
    { id: "145", nombre: "MAYOTTE" },
    { id: "146", nombre: "MICRONESIA" },
    { id: "147", nombre: "MOLDAVIA" },
    { id: "148", nombre: "MONGOLIA" },
    { id: "149", nombre: "MONTENEGRO" },
    { id: "150", nombre: "MONTSERRAT" },
    { id: "151", nombre: "MOZAMBIQUE" },
    { id: "152", nombre: "MYANMAR" },
    { id: "153", nombre: "MÉXICO" },
    { id: "154", nombre: "MÓNACO" },
    { id: "155", nombre: "NAMIBIA" },
    { id: "156", nombre: "NAURU" },
    { id: "157", nombre: "NEPAL" },
    { id: "158", nombre: "NICARAGUA" },
    { id: "159", nombre: "NIGER" },
    { id: "160", nombre: "NIGERIA" },
    { id: "161", nombre: "NIUE" },
    { id: "162", nombre: "NORFOLK" },
    { id: "163", nombre: "NORUEGA" },
    { id: "164", nombre: "NUEVA CALEDONIA" },
    { id: "165", nombre: "NUEVA ZELANDA" },
    { id: "166", nombre: "OMÁN" },
    { id: "167", nombre: "PAKISTÁN" },
    { id: "168", nombre: "PALAOS" },
    { id: "169", nombre: "PANAMÁ" },
    { id: "170", nombre: "PAPÚA NUEVA GUINEA" },
    { id: "171", nombre: "PARAGUAY" },
    { id: "172", nombre: "PAÍASES BAJOS" },
    { id: "173", nombre: "PERÚ" },
    { id: "174", nombre: "POLINESIA FRANCESA" },
    { id: "175", nombre: "POLONIA" },
    { id: "176", nombre: "PORTUGAL" },
    { id: "177", nombre: "PUERTO RICO" },
    { id: "178", nombre: "QATAR" },
    { id: "179", nombre: "REINO UNIDO" },
    { id: "180", nombre: "REPÚBLICA CENTROAFRICANA" },
    { id: "181", nombre: "REPÚBLICA CHECA" },
    { id: "184", nombre: "REPÚBLICA DE MACEDONIA" },
    { id: "185", nombre: "REPÚBLICA DEL CONGO" },
    { id: "182", nombre: "REPÚBLICA DEMOCRÁTICA DEL CONGO" },
    { id: "183", nombre: "REPÚBLICA DOMINICANA" },
    { id: "186", nombre: "REPÚBLICA ÁRABE SAHARAUI DEMOCRÁTICA" },
    { id: "188", nombre: "RUANDA" },
    { id: "189", nombre: "RUMANIA" },
    { id: "190", nombre: "RUSIA" },
    { id: "191", nombre: "SAINT-MARTIN" },
    { id: "192", nombre: "SAMOA" },
    { id: "193", nombre: "SAMOA AMERICANA" },
    { id: "194", nombre: "SAN BARTOLOMÉ" },
    { id: "195", nombre: "SAN CRISTÓBAL Y NIEVES" },
    { id: "196", nombre: "SAN MARINO" },
    { id: "197", nombre: "SAN PEDRO Y MIQUELÓN" },
    { id: "198", nombre: "SAN VICENTE Y LAS GRANADINAS" },
    { id: "199", nombre: "SANTA HELENA" },
    { id: "200", nombre: "SANTA LUCÍA" },
    { id: "201", nombre: "SAO TOMÉ Y PRINCIPE" },
    { id: "202", nombre: "SENEGAL" },
    { id: "203", nombre: "SERBIA" },
    { id: "204", nombre: "SEYCHELLES" },
    { id: "205", nombre: "SIERRA LEONA" },
    { id: "206", nombre: "SINGAPUR" },
    { id: "207", nombre: "SIRIA" },
    { id: "208", nombre: "SOMALIA" },
    { id: "209", nombre: "SRI LANKA" },
    { id: "210", nombre: "SUAZILANDIA" },
    { id: "211", nombre: "SUDÁFRICA" },
    { id: "212", nombre: "SUDÁN" },
    { id: "213", nombre: "SUECIA" },
    { id: "214", nombre: "SUIZA" },
    { id: "215", nombre: "SURINAM" },
    { id: "216", nombre: "SVALBARD Y JAN MAYEN" },
    { id: "217", nombre: "TAILANDIA" },
    { id: "218", nombre: "TAIWÁN" },
    { id: "219", nombre: "TANZANIA" },
    { id: "220", nombre: "TAYIKISTÁN" },
    { id: "221", nombre: "TERRITORIO BRITÁNICO DEL OCÉANO ÍANDICO" },
    { id: "222", nombre: "TERRITORIOS AUSTRALES FRANCESES" },
    { id: "223", nombre: "TERRITORIOS PALESTINOS" },
    { id: "224", nombre: "TIMOR ORIENTAL" },
    { id: "225", nombre: "TOGO" },
    { id: "226", nombre: "TOKELAU" },
    { id: "227", nombre: "TONGA" },
    { id: "228", nombre: "TRINIDAD Y TOBAGO" },
    { id: "229", nombre: "TURKMENISTÁN" },
    { id: "230", nombre: "TURQUÍA" },
    { id: "231", nombre: "TUVALU" },
    { id: "232", nombre: "TÚNEZ" },
    { id: "233", nombre: "UCRANIA" },
    { id: "234", nombre: "UGANDA" },
    { id: "235", nombre: "URUGUAY" },
    { id: "236", nombre: "UZBEKISTÁN" },
    { id: "237", nombre: "VANUATU" },
    { id: "238", nombre: "VENEZUELA" },
    { id: "239", nombre: "VIETNAM" },
    { id: "240", nombre: "WALLIS Y FUTUNA" },
    { id: "241", nombre: "YEMEN" },
    { id: "242", nombre: "YIBUTI" },
    { id: "243", nombre: "ZAMBIA" },
    { id: "244", nombre: "ZIMBABUE" },
  ],

  tipo_moneda: [
    { id: "dolar", nombre: "DOLAR" },
    { id: "euro", nombre: "EURO" },
    { id: "otro", nombre: "OTRO" },
    { id: "peso argentino", nombre: "PESO ARGENTINO" },
    { id: "peso chileno", nombre: "PESO CHILENO" },
    { id: "real", nombre: "REAL" },
  ],

  tipos_documentos: [
    { id: "5", nombre: "C.Ext" },
    { id: "1", nombre: "DNI" },
    { id: "6", nombre: "PAS" },
  ],

  cutis: [
    { id: "3", nombre: "Achinado" },
    { id: "1", nombre: "Blanco" },
    { id: "4", nombre: "Mulato" },
    { id: "5", nombre: "Negro" },
    { id: "2", nombre: "Trigueño" },
  ],

  cabello: [
    { id: "10", nombre: "Albino" },
    { id: "14", nombre: "Canoso" },
    { id: "7", nombre: "Castaño" },
    { id: "11", nombre: "Claro" },
    { id: "17", nombre: "Crespo" },
    { id: "15", nombre: "Lacio" },
    { id: "12", nombre: "Mediano" },
    { id: "18", nombre: "Motoso" },
    { id: "6", nombre: "Negro" },
    { id: "16", nombre: "Ondulado" },
    { id: "13", nombre: "Oscuro" },
    { id: "8", nombre: "Rojo" },
    { id: "9", nombre: "Rubio" },
  ],

  barba: [
    { id: "25", nombre: "Abierta" },
    { id: "20", nombre: "Afeitada" },
    { id: "24", nombre: "Cerrada" },
    { id: "23", nombre: "Corta" },
    { id: "28", nombre: "Cuadrada" },
    { id: "26", nombre: "En punta" },
    { id: "19", nombre: "Lampina" },
    { id: "21", nombre: "Larga" },
    { id: "22", nombre: "Mediana" },
    { id: "30", nombre: "Patillas" },
    { id: "29", nombre: "Perilla" },
    { id: "27", nombre: "Redonda" },
  ],

  bigote: [
    { id: "36", nombre: "Abundante" },
    { id: "31", nombre: "Afeitado" },
    { id: "33", nombre: "Corto" },
    { id: "35", nombre: "Largo" },
    { id: "34", nombre: "Mediano" },
    { id: "39", nombre: "Naciente" },
    { id: "38", nombre: "Ralo" },
    { id: "32", nombre: "Recortado" },
    { id: "37", nombre: "Regular" },
  ],

  frente: [
    { id: "49", nombre: "Altura alta" },
    { id: "47", nombre: "Altura baja" },
    { id: "48", nombre: "Altura mediana" },
    { id: "43", nombre: "Perfil Convezo" },
    { id: "40", nombre: "Perfil Fugitivo" },
    { id: "41", nombre: "Perfil Mediano" },
    { id: "44", nombre: "Perfil Ondulado" },
    { id: "45", nombre: "Perfil Recto" },
    { id: "46", nombre: "Perfil Senos frontales abultados" },
    { id: "42", nombre: "Perfil Vertical" },
  ],

  cejas: [
    { id: "63", nombre: "Altas" },
    { id: "50", nombre: "Arqueadas" },
    { id: "64", nombre: "Bajas" },
    { id: "60", nombre: "Cortas" },
    { id: "58", nombre: "Espesas" },
    { id: "62", nombre: "Extensas" },
    { id: "55", nombre: "Externa" },
    { id: "54", nombre: "Interna" },
    { id: "56", nombre: "Juntas" },
    { id: "61", nombre: "Medianas" },
    { id: "53", nombre: "Oblicuas" },
    { id: "51", nombre: "Onduladas" },
    { id: "59", nombre: "Ralas" },
    { id: "52", nombre: "Rectas" },
    { id: "57", nombre: "Separadas" },
  ],

  parpados: [
    { id: "65", nombre: "Abertura Chica" },
    { id: "67", nombre: "Abertura Grande" },
    { id: "68", nombre: "Abertura Horizontal" },
    { id: "66", nombre: "Abertura Mediana" },
    { id: "69", nombre: "Abertura Vertical" },
    { id: "74", nombre: "Modelado Abultados" },
    { id: "76", nombre: "Modelado Arrugados" },
    { id: "72", nombre: "Modelado Caidos" },
    { id: "75", nombre: "Modelado Con bolsa" },
    { id: "70", nombre: "Modelado Cubiertos" },
    { id: "77", nombre: "Modelado Derecho" },
    { id: "71", nombre: "Modelado Descubiertos" },
    { id: "73", nombre: "Modelado Hundidos" },
    { id: "78", nombre: "Modelado Izquierdo" },
  ],

  ojos: [
    { id: "86", nombre: "Círculo amarillo" },
    { id: "87", nombre: "Círculo anaranjado" },
    { id: "88", nombre: "Círculo castano" },
    { id: "90", nombre: "Globos achatada" },
    { id: "89", nombre: "Globos amplia" },
    { id: "79", nombre: "Iris izq. Apizarrado" },
    { id: "80", nombre: "Iris izq. Azul" },
    { id: "83", nombre: "Iris izq. Claro" },
    { id: "82", nombre: "Iris izq. Marron" },
    { id: "84", nombre: "Iris izq. Mediano" },
    { id: "85", nombre: "Iris izq. Oscuro" },
    { id: "81", nombre: "Iris izq. Verdes" },
  ],

  boca: [
    { id: "97", nombre: "Abierta" },
    { id: "95", nombre: "Apretada" },
    { id: "94", nombre: "Cerrada" },
    { id: "102", nombre: "Comisura a la derecha" },
    { id: "103", nombre: "Comisura a la izquierda" },
    { id: "99", nombre: "Comisura bajadas" },
    { id: "98", nombre: "Comisura horizontales" },
    { id: "100", nombre: "Comisura levantadas" },
    { id: "101", nombre: "Comisura Oblicuas" },
    { id: "96", nombre: "Entreabierta" },
    { id: "93", nombre: "Grande" },
    { id: "92", nombre: "Mediana" },
    { id: "91", nombre: "Pequeña" },
  ],

  nariz: [
    { id: "120", nombre: "Ancho achatada" },
    { id: "119", nombre: "Ancho amplia" },
    { id: "117", nombre: "Ancho fina" },
    { id: "118", nombre: "Ancho mediana" },
    { id: "111", nombre: "Base bajada" },
    { id: "112", nombre: "Base horizontal" },
    { id: "107", nombre: "Dorso concavo" },
    { id: "109", nombre: "Dorso convexo" },
    { id: "110", nombre: "Dorso ondulado" },
    { id: "108", nombre: "Dorso Recto" },
    { id: "105", nombre: "Raiz mediana" },
    { id: "104", nombre: "Raiz pequena" },
    { id: "106", nombre: "Raiz profunda" },
    { id: "116", nombre: "Tamaño grande" },
    { id: "115", nombre: "Tamaño mediana" },
    { id: "114", nombre: "Tamaño pequena" },
  ],

  tatuaje: [
    { id: "163", nombre: "No" },
    { id: "162", nombre: "Si" },
  ],

  labios: [
    { id: "122", nombre: "Bordes finos" },
    { id: "124", nombre: "Bordes gruesos" },
    { id: "121", nombre: "Bordes imperceptibles" },
    { id: "123", nombre: "Bordes medianos" },
    { id: "125", nombre: "Bordes prominentes" },
    { id: "126", nombre: "Inferior" },
    { id: "127", nombre: "Superior" },
  ],

  menton: [
    { id: "136", nombre: "Altura alto" },
    { id: "134", nombre: "Altura corto" },
    { id: "135", nombre: "Altura mediano" },
    { id: "139", nombre: "Ancho amplio" },
    { id: "137", nombre: "Ancho estrecho" },
    { id: "138", nombre: "Ancho normal" },
    { id: "140", nombre: "Partic. con hoyo" },
    { id: "141", nombre: "Partic. con surco" },
    { id: "142", nombre: "Partic. supramentoniano" },
    { id: "128", nombre: "Perfil fugitivo" },
    { id: "129", nombre: "Perfil mediano" },
    { id: "131", nombre: "Perfil saliente" },
    { id: "130", nombre: "Perfil vertical" },
    { id: "133", nombre: "Plano" },
    { id: "132", nombre: "Redondo" },
  ],

  oreja: [
    { id: "152", nombre: "Corto" },
    { id: "155", nombre: "Deformado" },
    { id: "145", nombre: "Derecha grande" },
    { id: "144", nombre: "Derecha mediana" },
    { id: "143", nombre: "Derecha pequena" },
    { id: "147", nombre: "Helix con borde" },
    { id: "149", nombre: "Helix deformado" },
    { id: "148", nombre: "Helix protuberancia" },
    { id: "146", nombre: "Helix sin borde" },
    { id: "154", nombre: "Largo" },
    { id: "151", nombre: "Lóbulo adherido" },
    { id: "150", nombre: "Lóbulo suelto" },
    { id: "153", nombre: "Mediano" },
    { id: "156", nombre: "Perforado" },
  ],

  marcas: [
    { id: "7", nombre: "AEROPUCH" },
    { id: "8", nombre: "ALFA ROMEO" },
    { id: "9", nombre: "APPIA" },
    { id: "10", nombre: "AUDI" },
    { id: "11", nombre: "BMW" },
    { id: "12", nombre: "CADILLAC" },
    { id: "13", nombre: "CHERRY" },
    { id: "14", nombre: "CHEVROLET" },
    { id: "15", nombre: "DAIHATSU" },
    { id: "16", nombre: "DODGE" },
    { id: "17", nombre: "ESTANCIERA" },
    { id: "18", nombre: "FIAT" },
    { id: "19", nombre: "FORD" },
    { id: "20", nombre: "GUERRERO" },
    { id: "21", nombre: "GUZZI" },
    { id: "22", nombre: "HARLEY DAVISON" },
    { id: "23", nombre: "HONDA" },
    { id: "24", nombre: "HYOSUNG" },
    { id: "25", nombre: "HYUNDAI" },
    { id: "26", nombre: "JAGUAR" },
    { id: "27", nombre: "JEEP" },
    { id: "28", nombre: "KAWASAKI" },
    { id: "29", nombre: "KIA" },
    { id: "30", nombre: "KRYPTON" },
    { id: "31", nombre: "KYMCO" },
    { id: "32", nombre: "LAND ROVER" },
    { id: "33", nombre: "MAVERICK" },
    { id: "34", nombre: "MAZDA" },
    { id: "35", nombre: "MINI" },
    { id: "36", nombre: "MITSUBISHI" },
    { id: "37", nombre: "MOTOMEL" },
    { id: "38", nombre: "MS. BENZ" },
    { id: "39", nombre: "NISSAN" },
    { id: "2", nombre: "OTRAS MARCAS" },
    { id: "40", nombre: "PEUGEOT" },
    { id: "41", nombre: "PIAGGIO" },
    { id: "42", nombre: "RASTROJERO" },
    { id: "43", nombre: "RENAULT" },
    { id: "44", nombre: "ROVER" },
    { id: "45", nombre: "SALATINO" },
    { id: "46", nombre: "SIAMBRETTA" },
    { id: "47", nombre: "SUBARU" },
    { id: "48", nombre: "SUMO" },
    { id: "49", nombre: "SUZUKI" },
    { id: "50", nombre: "TORINO" },
    { id: "51", nombre: "TOYOTA" },
    { id: "52", nombre: "VOLVO" },
    { id: "53", nombre: "VW" },
    { id: "54", nombre: "YAMAHA" },
    { id: "55", nombre: "ZANELLA" },
  ],

  cuadrantes: [
    { id: "fcc5858e-a411-11e4-8b30-0025d318e182", nombre: "CAPITAL - 1" },
    { id: "07a0c625-7100-1033-a5ef-c0a7072ac148", nombre: "CAPITAL - 10" },
    { id: "5ead9370-2a2f-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 11" },
    { id: "bb4fb278-2a31-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 12" },
    { id: "2e7061df-2a38-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 13" },
    { id: "c2802076-2a3c-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 14" },
    { id: "252dc09f-2a3e-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 15" },
    { id: "1f9ca87c-2a3f-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 16" },
    { id: "a32c2328-2a40-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 17" },
    { id: "b71f3b12-2a40-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 18" },
    { id: "69d1c52b-2bd4-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 19" },
    { id: "07863f66-7100-1033-a5ef-c0a7072ac148", nombre: "CAPITAL - 2" },
    { id: "dbe2b5ec-2bd5-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 20" },
    { id: "6613a11a-2a3b-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 21" },
    { id: "8dc932d3-2a3a-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 22" },
    { id: "eba593a7-2a39-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 23" },
    { id: "5539c3f5-2a39-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 24" },
    { id: "07895f4e-7100-1033-a5ef-c0a7072ac148", nombre: "CAPITAL - 3" },
    { id: "078c84d5-7100-1033-a5ef-c0a7072ac148", nombre: "CAPITAL - 4" },
    { id: "078fb027-7100-1033-a5ef-c0a7072ac148", nombre: "CAPITAL - 5" },
    { id: "ab9e54ec-87c0-11e5-82b1-fa163e1d9e34", nombre: "ALBARDON - 50" },
    { id: "0792d8b5-7100-1033-a5ef-c0a7072ac148", nombre: "CAPITAL - 6" },
    { id: "82faccc6-2a56-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 7" },
    { id: "1de0365a-2a54-11e5-bb0d-fa163e1d9e34", nombre: "CAPITAL - 8" },
    { id: "c8e215f6-ba51-11e7-b889-bc5ff4cd6758", nombre: "ALBARDON - 8" },
    { id: "079da016-7100-1033-a5ef-c0a7072ac148", nombre: "CAPITAL - 9" },
    { id: "c4460828-9ed8-11e5-be6e-fa163e1d9e34", nombre: "CHIMBAS - Chimbas 1" },
    { id: "ea9e4e5a-a5c8-11e5-be6e-fa163e1d9e34", nombre: "CHIMBAS - nn" },
    { id: "8d3ef037-a8df-11e5-be6e-fa163e1d9e34", nombre: "CHIMBAS - oijoij" },
  ],

  jurisdicciones: [
    { id: "54223fa6-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 1ra" },
    { id: "542249b3-9cae-11e4-94c2-0025d318e182", nombre: "COMISARÍA 2ra" },
    { id: "54224d72-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 3ra " },
    { id: "54225140-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 4ra " },
    { id: "54225140-9cae-11e4-94c2-0025d318e182", nombre: "COMISARIA 4ra " },
    { id: "219f08fb-f505-11e4-a638-0025d318e182", nombre: "UNIDAD RURAL  ALBARDÓN" },
    { id: "5feb7b59-a043-11e5-be6e-fa163e1d9e34", nombre: "POLICÍA RURAL VILLA INDEPENDENCIA" },
  ],

  id_registro: "",

  tipo_registro: "denuncia",

  nacionalidadJSON: [
    { id: "12", nombre: "AFGANISTÁN" },
    { id: "2", nombre: "ALBANIA" },
    { id: "3", nombre: "ALEMANIA" },
    { id: "5", nombre: "ANDORRA" },
    { id: "6", nombre: "ANGOLA" },
    { id: "7", nombre: "ANGUILA" },
    { id: "8", nombre: "ANTIGUA Y BARBUDA" },
    { id: "9", nombre: "ANTILLAS NEERLANDESAS" },
    { id: "10", nombre: "ANTÁRTIDA" },
    { id: "11", nombre: "ARABIA SAUDITA" },
    { id: "4", nombre: "ARGELIA" },
    { id: "1", nombre: "ARGENTINA" },
    { id: "13", nombre: "ARMENIA" },
    { id: "14", nombre: "ARUBA" },
    { id: "15", nombre: "AUSTRALIA" },
    { id: "16", nombre: "AUSTRIA" },
    { id: "17", nombre: "AZERBAIYÁN" },
    { id: "18", nombre: "BAHAMAS" },
    { id: "20", nombre: "BANGLADESH" },
    { id: "21", nombre: "BARBADOS" },
    { id: "22", nombre: "BELICE" },
    { id: "23", nombre: "BENIN" },
    { id: "24", nombre: "BERMUDAS" },
    { id: "25", nombre: "BIELORRUSIA" },
    { id: "26", nombre: "BOLIVIA" },
    { id: "27", nombre: "BOSNIA Y HERZEGOVINA" },
    { id: "28", nombre: "BOTSWANA" },
    { id: "29", nombre: "BRASIL" },
    { id: "31", nombre: "BULGARIA" },
    { id: "32", nombre: "BURKINA FASO" },
    { id: "33", nombre: "BURUNDI" },
    { id: "34", nombre: "BUTÁN" },
    { id: "35", nombre: "BÉLGICA" },
    { id: "36", nombre: "CABO VERDE" },
    { id: "37", nombre: "CAMBOYA" },
    { id: "38", nombre: "CAMERÚN" },
    { id: "39", nombre: "CANADÁ" },
    { id: "40", nombre: "CHAD" },
    { id: "41", nombre: "CHILE" },
    { id: "42", nombre: "CHINA" },
    { id: "43", nombre: "CHIPRE" },
    { id: "44", nombre: "CIUDAD DEL VATICANO" },
    { id: "45", nombre: "COLOMBIA" },
    { id: "46", nombre: "COMORAS" },
    { id: "47", nombre: "COREA DEL NORTE" },
    { id: "48", nombre: "COREA DEL SUR" },
    { id: "50", nombre: "COSTA DE MARFIL" },
    { id: "49", nombre: "COSTA RICA" },
    { id: "51", nombre: "CROACIA" },
    { id: "52", nombre: "CUBA" },
    { id: "53", nombre: "DINAMARCA" },
    { id: "54", nombre: "DOMINICA" },
    { id: "55", nombre: "ECUADOR" },
    { id: "56", nombre: "EGIPTO" },
    { id: "57", nombre: "EL SALVADOR" },
    { id: "58", nombre: "EMIRATOS ÁRABES UNIDOS" },
    { id: "59", nombre: "ERITREA" },
    { id: "60", nombre: "ESLOVAQUIA" },
    { id: "61", nombre: "ESLOVENIA" },
    { id: "62", nombre: "ESPAÑA" },
    { id: "63", nombre: "ESTADOS UNIDOS" },
    { id: "64", nombre: "ESTONIA" },
    { id: "65", nombre: "ETIOPÍA" },
    { id: "66", nombre: "FILIPINAS" },
    { id: "67", nombre: "FINLANDIA" },
    { id: "68", nombre: "FIYI" },
    { id: "69", nombre: "FRANCIA" },
    { id: "71", nombre: "GAMBIA" },
    { id: "72", nombre: "GEORGIA" },
    { id: "73", nombre: "GHANA" },
    { id: "74", nombre: "GIBRALTAR" },
    { id: "75", nombre: "GRANADA" },
    { id: "76", nombre: "GRECIA" },
    { id: "77", nombre: "GROENLANDIA" },
    { id: "78", nombre: "GUADALUPE" },
    { id: "79", nombre: "GUAM" },
    { id: "80", nombre: "GUATEMALA" },
    { id: "81", nombre: "GUAYANA FRANCESA" },
    { id: "82", nombre: "GUERNSEY" },
    { id: "83", nombre: "GUINEA" },
    { id: "84", nombre: "GUINEA ECUATORIAL" },
    { id: "85", nombre: "GUINEA-BISSAU" },
    { id: "86", nombre: "GUYANA" },
    { id: "87", nombre: "HAITÍA" },
    { id: "88", nombre: "HONDURAS" },
    { id: "89", nombre: "HONG KONG" },
    { id: "90", nombre: "HUNGRÍA" },
    { id: "91", nombre: "INDIA" },
    { id: "92", nombre: "INDONESIA" },
    { id: "93", nombre: "IRAQ" },
    { id: "94", nombre: "IRLANDA" },
    { id: "95", nombre: "IRÁN" },
    { id: "96", nombre: "ISLA BOUVET" },
    { id: "97", nombre: "ISLA DE MAN" },
    { id: "98", nombre: "ISLA DE NAVIDAD" },
    { id: "99", nombre: "ISLANDIA" },
    { id: "100", nombre: "ISLAS CAIMÁN" },
    { id: "101", nombre: "ISLAS COCOS" },
    { id: "102", nombre: "ISLAS COOK" },
    { id: "103", nombre: "ISLAS FEROE" },
    { id: "104", nombre: "ISLAS GEORGIAS DEL SUR Y SANDWICH DEL SUR" },
    { id: "105", nombre: "ISLAS HEARD Y MCDONALD" },
    { id: "106", nombre: "ISLAS MARIANAS DEL NORTE" },
    { id: "107", nombre: "ISLAS MARSHALL" },
    { id: "108", nombre: "ISLAS PITCAIRN" },
    { id: "109", nombre: "ISLAS SALOMÓN" },
    { id: "110", nombre: "ISLAS TURCAS Y CAICOS" },
    { id: "113", nombre: "ISLAS ULTRAMARINAS DE ESTADOS UNIDOS" },
    { id: "111", nombre: "ISLAS VÍARGENES BRITÁNICAS" },
    { id: "112", nombre: "ISLAS VÍARGENES ESTADOUNIDENSES" },
    { id: "114", nombre: "ISRAEL" },
    { id: "115", nombre: "ITALIA" },
    { id: "116", nombre: "JAMAICA" },
    { id: "117", nombre: "JAPÓN" },
    { id: "118", nombre: "JERSEY" },
    { id: "119", nombre: "JORDANIA" },
    { id: "120", nombre: "KAZAJISTÁN" },
    { id: "121", nombre: "KENIA" },
    { id: "122", nombre: "KIRGUISTÁN" },
    { id: "123", nombre: "KIRIBATI" },
    { id: "124", nombre: "KUWAIT" },
    { id: "125", nombre: "LAOS" },
    { id: "126", nombre: "LESOTO" },
    { id: "127", nombre: "LETONIA" },
    { id: "128", nombre: "LIBERIA" },
    { id: "129", nombre: "LIBIA" },
    { id: "130", nombre: "LIECHTENSTEIN" },
    { id: "131", nombre: "LITUANIA" },
    { id: "132", nombre: "LUXEMBURGO" },
    { id: "133", nombre: "LÍABANO" },
    { id: "134", nombre: "MACAO" },
    { id: "135", nombre: "MADAGASCAR" },
    { id: "136", nombre: "MALASIA" },
    { id: "137", nombre: "MALAUI" },
    { id: "138", nombre: "MALDIVAS" },
    { id: "139", nombre: "MALTA" },
    { id: "141", nombre: "MARRUECOS" },
    { id: "142", nombre: "MARTINICA" },
    { id: "143", nombre: "MAURICIO" },
    { id: "144", nombre: "MAURITANIA" },
    { id: "145", nombre: "MAYOTTE" },
    { id: "146", nombre: "MICRONESIA" },
    { id: "147", nombre: "MOLDAVIA" },
    { id: "148", nombre: "MONGOLIA" },
    { id: "149", nombre: "MONTENEGRO" },
    { id: "150", nombre: "MONTSERRAT" },
    { id: "151", nombre: "MOZAMBIQUE" },
    { id: "152", nombre: "MYANMAR" },
    { id: "153", nombre: "MÉXICO" },
    { id: "154", nombre: "MÓNACO" },
    { id: "155", nombre: "NAMIBIA" },
    { id: "156", nombre: "NAURU" },
    { id: "157", nombre: "NEPAL" },
    { id: "158", nombre: "NICARAGUA" },
    { id: "159", nombre: "NIGER" },
    { id: "160", nombre: "NIGERIA" },
    { id: "161", nombre: "NIUE" },
    { id: "162", nombre: "NORFOLK" },
    { id: "163", nombre: "NORUEGA" },
    { id: "164", nombre: "NUEVA CALEDONIA" },
    { id: "165", nombre: "NUEVA ZELANDA" },
    { id: "166", nombre: "OMÁN" },
    { id: "167", nombre: "PAKISTÁN" },
    { id: "168", nombre: "PALAOS" },
    { id: "169", nombre: "PANAMÁ" },
    { id: "170", nombre: "PAPÚA NUEVA GUINEA" },
    { id: "171", nombre: "PARAGUAY" },
    { id: "172", nombre: "PAÍASES BAJOS" },
    { id: "173", nombre: "PERÚ" },
    { id: "174", nombre: "POLINESIA FRANCESA" },
    { id: "175", nombre: "POLONIA" },
    { id: "176", nombre: "PORTUGAL" },
    { id: "177", nombre: "PUERTO RICO" },
    { id: "178", nombre: "QATAR" },
    { id: "179", nombre: "REINO UNIDO" },
    { id: "180", nombre: "REPÚBLICA CENTROAFRICANA" },
    { id: "181", nombre: "REPÚBLICA CHECA" },
    { id: "184", nombre: "REPÚBLICA DE MACEDONIA" },
    { id: "185", nombre: "REPÚBLICA DEL CONGO" },
    { id: "182", nombre: "REPÚBLICA DEMOCRÁTICA DEL CONGO" },
    { id: "183", nombre: "REPÚBLICA DOMINICANA" },
    { id: "186", nombre: "REPÚBLICA ÁRABE SAHARAUI DEMOCRÁTICA" },
    { id: "188", nombre: "RUANDA" },
    { id: "189", nombre: "RUMANIA" },
    { id: "190", nombre: "RUSIA" },
    { id: "191", nombre: "SAINT-MARTIN" },
    { id: "192", nombre: "SAMOA" },
    { id: "193", nombre: "SAMOA AMERICANA" },
    { id: "194", nombre: "SAN BARTOLOMÉ" },
    { id: "195", nombre: "SAN CRISTÓBAL Y NIEVES" },
    { id: "196", nombre: "SAN MARINO" },
    { id: "197", nombre: "SAN PEDRO Y MIQUELÓN" },
    { id: "198", nombre: "SAN VICENTE Y LAS GRANADINAS" },
    { id: "199", nombre: "SANTA HELENA" },
    { id: "200", nombre: "SANTA LUCÍA" },
    { id: "201", nombre: "SAO TOMÉ Y PRINCIPE" },
    { id: "202", nombre: "SENEGAL" },
    { id: "203", nombre: "SERBIA" },
    { id: "204", nombre: "SEYCHELLES" },
    { id: "205", nombre: "SIERRA LEONA" },
    { id: "206", nombre: "SINGAPUR" },
    { id: "207", nombre: "SIRIA" },
    { id: "208", nombre: "SOMALIA" },
    { id: "209", nombre: "SRI LANKA" },
    { id: "210", nombre: "SUAZILANDIA" },
    { id: "211", nombre: "SUDÁFRICA" },
    { id: "212", nombre: "SUDÁN" },
    { id: "213", nombre: "SUECIA" },
    { id: "214", nombre: "SUIZA" },
    { id: "215", nombre: "SURINAM" },
    { id: "216", nombre: "SVALBARD Y JAN MAYEN" },
    { id: "217", nombre: "TAILANDIA" },
    { id: "218", nombre: "TAIWÁN" },
    { id: "219", nombre: "TANZANIA" },
    { id: "220", nombre: "TAYIKISTÁN" },
    { id: "221", nombre: "TERRITORIO BRITÁNICO DEL OCÉANO ÍANDICO" },
    { id: "222", nombre: "TERRITORIOS AUSTRALES FRANCESES" },
    { id: "223", nombre: "TERRITORIOS PALESTINOS" },
    { id: "224", nombre: "TIMOR ORIENTAL" },
    { id: "225", nombre: "TOGO" },
    { id: "226", nombre: "TOKELAU" },
    { id: "227", nombre: "TONGA" },
    { id: "228", nombre: "TRINIDAD Y TOBAGO" },
    { id: "229", nombre: "TURKMENISTÁN" },
    { id: "230", nombre: "TURQUÍA" },
    { id: "231", nombre: "TUVALU" },
    { id: "232", nombre: "TÚNEZ" },
    { id: "233", nombre: "UCRANIA" },
    { id: "234", nombre: "UGANDA" },
    { id: "235", nombre: "URUGUAY" },
    { id: "236", nombre: "UZBEKISTÁN" },
    { id: "237", nombre: "VANUATU" },
    { id: "238", nombre: "VENEZUELA" },
    { id: "239", nombre: "VIETNAM" },
    { id: "240", nombre: "WALLIS Y FUTUNA" },
    { id: "241", nombre: "YEMEN" },
    { id: "242", nombre: "YIBUTI" },
    { id: "243", nombre: "ZAMBIA" },
    { id: "244", nombre: "ZIMBABUE" },
  ],

  departamentoJSON: [
    { id: "71c04abf-ce2d-11e4-a042-0090f58f4f32", nombre: "25 DE MAYO" },
    { id: "7164a28a-ce2d-11e4-a042-0090f58f4f32", nombre: "9 DE JULIO" },
    { id: "7115dec8-ce2d-11e4-a042-0090f58f4f32", nombre: "ALBARDON" },
    { id: "7123cb1b-ce2d-11e4-a042-0090f58f4f32", nombre: "ANGACO" },
    { id: "712e0fb6-ce2d-11e4-a042-0090f58f4f32", nombre: "CALINGASTA" },
    { id: "9536aa48-b0a5-11e4-9ace-0025d318e182", nombre: "CAPITAL" },
    { id: "71385581-ce2d-11e4-a042-0090f58f4f32", nombre: "CAUCETE" },
    { id: "71444675-ce2d-11e4-a042-0090f58f4f32", nombre: "CHIMBAS" },
    { id: "714e85c8-ce2d-11e4-a042-0090f58f4f32", nombre: "IGLESIA" },
    { id: "7158ca33-ce2d-11e4-a042-0090f58f4f32", nombre: "JACHAL" },
    { id: "716ed4c6-ce2d-11e4-a042-0090f58f4f32", nombre: "POCITO" },
    { id: "47f273e2-9cc0-11e4-94c2-0025d318e182", nombre: "RAWSON" },
    { id: "71791441-ce2d-11e4-a042-0090f58f4f32", nombre: "RIVADAVIA" },
    { id: "7184de06-ce2d-11e4-a042-0090f58f4f32", nombre: "SAN MARTIN" },
    { id: "718f0e5f-ce2d-11e4-a042-0090f58f4f32", nombre: "SANTA LUCIA" },
    { id: "71a00fb5-ce2d-11e4-a042-0090f58f4f32", nombre: "SARMIENTO" },
    { id: "71aa93f2-ce2d-11e4-a042-0090f58f4f32", nombre: "ULLUM" },
    { id: "71b51e9b-ce2d-11e4-a042-0090f58f4f32", nombre: "VALLE FERTIL" },
    { id: "71caaf12-ce2d-11e4-a042-0090f58f4f32", nombre: "ZONDA" },
  ],

  provinciaJSON: [
    { id: "4", nombre: "BUENOS AIRES" },
    { id: "3", nombre: "CAPITAL FEDERAL" },
    { id: "5", nombre: "CATAMARCA" },
    { id: "8", nombre: "CHACO" },
    { id: "9", nombre: "CHUBUT" },
    { id: "7", nombre: "CORRIENTES" },
    { id: "6", nombre: "CÓRDOBA" },
    { id: "10", nombre: "ENTRE RÍAOS" },
    { id: "11", nombre: "FORMOSA" },
    { id: "12", nombre: "JUJUY" },
    { id: "13", nombre: "LA PAMPA" },
    { id: "14", nombre: "LA RIOJA" },
    { id: "2", nombre: "MENDOZA" },
    { id: "15", nombre: "MISIONES" },
    { id: "16", nombre: "NEUQUÉN" },
    { id: "17", nombre: "RÍAO NEGRO" },
    { id: "18", nombre: "SALTA" },
    { id: "1", nombre: "SAN JUAN" },
    { id: "19", nombre: "SAN LUIS" },
    { id: "20", nombre: "SANTA CRUZ" },
    { id: "21", nombre: "SANTA FE" },
    { id: "22", nombre: "SANTIAGO DEL ESTERO" },
    { id: "23", nombre: "TIERRA DEL FUEGO" },
    { id: "24", nombre: "TUCUMÁN" },
  ],

  rubrosJSON: [
    { id: "14", nombre: "Entidad pública estatal- Entidad Internacional (ONU, OEA, etc)" },
    {
      id: "5",
      nombre: "Entidad pública estatal- Entidades Autárquicas (AFIP, Banco Central, etc)",
    },
    { id: "3", nombre: "Entidad pública estatal- Estado Municipal" },
    { id: "1", nombre: "Entidad pública estatal- Estado Nacional" },
    { id: "2", nombre: "Entidad pública estatal- Estado Provincial" },
    { id: "4", nombre: "Entidad pública estatal- Iglesia Católica" },
    { id: "15", nombre: "Entidad pública estatal- Integraciones Regionales" },
    { id: "6", nombre: "Entidad pública estatal-Administrativa" },
    { id: "8", nombre: "Entidad pública estatal-Administrativa - c/competencia especial" },
    { id: "7", nombre: "Entidad pública estatal-Administrativa - c/competencia general" },
    { id: "10", nombre: "Entidad pública estatal-Administrativa - Corporación Regional" },
    { id: "9", nombre: "Entidad pública estatal-Administrativa - independiente" },
    { id: "11", nombre: "Entidad pública estatal-Comerciales o Industriales" },
    { id: "12", nombre: "Entidad pública estatal-Comerciales o Industriales-Empresas del Estado" },
    {
      id: "13",
      nombre: "Entidad pública estatal-Comerciales o Industriales-Sociedades del Estado",
    },
    {
      id: "16",
      nombre:
        "Entidad pública no estatal- Colegios públicos de profesionales (Abogados, Martilleros, etc)",
    },
    { id: "17", nombre: "Entidad pública no estatal- Obras Sociales" },
    { id: "18", nombre: "Entidad pública no estatal-Con participación estatal" },
    { id: "21", nombre: "Entidad pública no estatal-Con participación estatal-Asoc. dirigidas" },
    {
      id: "22",
      nombre: "Entidad pública no estatal-Con participación estatal-Entes reguladores no estatales",
    },
    {
      id: "20",
      nombre:
        "Entidad pública no estatal-Con participación estatal-Soc. anónima c/participación estatal mayoritaria",
    },
    {
      id: "19",
      nombre:
        "Entidad pública no estatal-Con participación estatal-Soc. de economía mixta, con facultades o privilegios públicos",
    },
    { id: "23", nombre: "Entidad pública no estatal-Sin participación estatal" },
    {
      id: "24",
      nombre: "Entidad pública no estatal-Sin participación estatal- Corporaciones Públicas",
    },
    {
      id: "25",
      nombre:
        "Entidad pública no estatal-Sin participación estatal- Fundaciones públicas no estatales",
    },
    { id: "26", nombre: "Entidades privadas-Con participación Estatal" },
    { id: "27", nombre: "Entidades privadas-Con participación Estatal- Participación Estatutaria" },
    { id: "28", nombre: "Entidades privadas-Sin participación Estatal" },
    { id: "44", nombre: "Entidades privadas-Sin participación Estatal- De interés Privado" },
    { id: "29", nombre: "Entidades privadas-Sin participación Estatal- De interés Público" },
    {
      id: "40",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Con fines de lucro",
    },
    {
      id: "43",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Con fines de lucro - Empresas prestadoras de Servicios Públicos (electricidad, transporte, etc)",
    },
    {
      id: "41",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Con fines de lucro - Entidad Bancaria",
    },
    {
      id: "42",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Con fines de lucro - Entidad Financiera y de Seguros",
    },
    {
      id: "30",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro",
    },
    {
      id: "36",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Asociaciones de bien común",
    },
    {
      id: "38",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Bomberos Voluntarios",
    },
    {
      id: "35",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Clubes",
    },
    {
      id: "37",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Cooperadora escolar",
    },
    {
      id: "31",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Cooperativas",
    },
    {
      id: "32",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Fundaciones",
    },
    {
      id: "33",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Mutuales",
    },
    {
      id: "39",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Otros",
    },
    {
      id: "34",
      nombre:
        "Entidades privadas-Sin participación Estatal- De interés Público- Sin fines de lucro- Sindicatos",
    },
  ],

  visible: "si",

  iddependencias: "54223fa6-9cae-11e4-94c2-0025d318e182",

  accion: 0,
};
